import { Component, OnInit, OnDestroy, ElementRef, ViewChild, AfterViewInit, HostListener, NgZone } from '@angular/core';
import videojs from 'video.js';
import 'videojs-contrib-eme';
import YTPlayer from 'yt-player';
import { ApiService } from 'src/app/core/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { environment } from "../../../../environments/environment"
import { Location } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from 'src/app/core/auth/auth.service';
import { PlayQueueService } from 'src/app/core/services/play-queue.service';
import { WatchTimeService } from 'src/app/core/services/watch-time.service';
import 'videojs-contrib-quality-levels';
import 'videojs-hls-quality-selector';


@Component({
  selector: 'app-drm-player',
  templateUrl: './drmplayer.component.html',
  styleUrls: ['./drmplayer.component.scss']
})

export class DrmPlayerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('videoPlayer') videoPlayer: ElementRef;
  @ViewChild('playerHost') playerHost: ElementRef;

  player: any;
  browser: string = 'Non-DRM browser';
  drmType: string = 'No DRM';
  supportSl3000: boolean = false;
  supportL1: boolean = false;
  params: any;
  fullParams: any;
  videos: any;
  currentVideos: any;
  dashUri = null;
  hlsUri = null;
  encrypted: any;
  licenseUri = 'https://license-global.pallycon.com/ri/licenseManager.do';
  widevineCertUri = 'https://license-global.pallycon.com/ri/widevineCert.do?siteId=HLEH';
  fairplayCertUri = 'https://drm-license.doverunner.com/ri/fpsKeyManager.do?siteId=HLEH';

  // Tokens
  widevineToken = "";
  playreadyToken = this.widevineToken;
  fairplayToken = this.widevineToken;
  showNextButton = false;
  subTitle = [];

  currentDecryptUser: any;
  userId: any;
  userName: any;
  private titleComp: any;
  private emailComp: any;
  showPlayErrorPopup = false;
  subscribeToWatch: string = 'This is a paid video. Please subscribe to watch.';
  subscribeNow: string = 'subscribe Now';
  nextEpisodeSlug = false;
  isNavigatingNext = false;
  playNextPartUrl = '';
  nextPart: string = 'Next part »';

  // Admin playlist (?playlist_id=...) support: auto-advance through playlist_videos.
  adminPlaylistSlug: string = '';

  /** Third-party embeds — YouTube (videos.is_embed === 1) and Vimeo (videos.is_vimeo === 1).
   * They carry no HLS/DASH source, so videojs/EME is never initialised for them: YouTube
   * runs through a yt-player instance, Vimeo through a plain embed iframe. Both reuse the
   * player's own chrome (back button + title) and the up-next / related-videos overlays. */
  isYoutube = false;
  isVimeo = false;
  ytPlayer: any = null;
  /** Sanitized Vimeo embed_url, bound to the iframe src. */
  vimeoUrl: SafeResourceUrl = null;
  embedTitle = '';
  ytPoster = '';
  /** Poster + play button shown until playback actually starts (YouTube blocks unmuted autoplay). */
  ytShowPoster = true;
  /** YouTube/Vimeo draw their own title bar on hover — hide ours while the pointer is over them. */
  embedHovered = false;

  // "Up next" auto-advance card + 15s countdown (web-series / playlist / recommended).
  nextUpVideo: any = null;
  nextUpUrl = '';
  private nextUpOverlayEl: HTMLElement | null = null;
  private nextUpCountEl: HTMLElement | null = null;
  private nextUpVisible = false;
  /** Once the user cancels autoplay for the current video, don't auto-advance/re-show. */
  private nextUpDismissed = false;

  // Slide-in related-videos sidebar (button-triggered, scrollable, click-to-play)
  showSidebar = false;
  sidebarVideos: any[] = [];
  readonly sidebarDefaultPoster = 'https://dyo1wwfvu9av7.cloudfront.net/jkp/common/default-poster.png';

  // YouTube-style related-videos end screen
  relatedVideos: any[] = [];
  private relatedOverlayEl: HTMLElement | null = null;
  private relatedOverlayVisible = false;
  /** Once the user closes the overlay for the current video, don't auto-show it again */
  private relatedDismissed = false;
  /** Seconds before the end at which the related grid starts appearing (like YouTube) */
  private readonly relatedShowThreshold = 15;

  /** Customer subscription setting (v2/customer/subscription -> auto_play === 1).
   * When true, the current video auto-advances to the next one (web-series episode,
   * admin playlist entry, or top recommended video) with a 15s countdown. When false,
   * playback simply stops at the end and the user picks the next video manually. */
  autoPlayEnabled = false;
  /** Set by a play queue flagged autoPlay (e.g. the by-publish-date sequence): auto-advance
   * stays on even when the account's auto_play setting is off, until the user toggles it. */
  private queueForcesAutoPlay = false;
  /** Settings-menu button instance (videojs component) — hosts the auto_play toggle. */
  private settingsBtn: any = null;

  /** True only while the tab-switch handler is the one that opened PiP, so returning to
   * the tab pops it back inline without touching a PiP the user opened themselves. */
  private pipAutoEntered = false;

  /** Media time at the previous timeupdate, used to measure genuine playback for the
   * per-day watch total. `null` = anchor dropped (seek/pause/buffer), next tick only re-anchors. */
  private watchTick: number | null = null;
  /** True while we're waiting for the user's first interaction after returning to the tab. */
  private pipExitGestureArmed = false;
  /** Kept as single bound references so the same listeners can be removed later. */
  private onVisibilityChange = () => this.handleVisibilityChange();
  private onPipExitGesture = () => {
    this.disarmPipExitGesture();
    this.exitAutoPip();
  };
  private onLeavePip = () => {
    this.pipAutoEntered = false;
    this.disarmPipExitGesture();
  };

  constructor(private apiService: ApiService,
    private route: ActivatedRoute,
    private _location: Location,
    private authService: AuthService,
    private router: Router,
    private zone: NgZone,
    private sanitizer: DomSanitizer,
    private playQueue: PlayQueueService,
    private watchTime: WatchTimeService) {
    /** Keep the admin playlist context (?playlist_id=...) so watchvideo returns
     * playlist_videos and next-episode navigation preserves the playlist. */
    this.route.queryParams.subscribe(qp => {
      if (qp && qp['playlist_id']) {
        this.adminPlaylistSlug = qp['playlist_id'];
      }
    });
    this.route.params.subscribe(params => {
      const prevVideoId = this.fullParams && this.fullParams['video_id'];
      const isEpisodeSwitch = prevVideoId && prevVideoId !== params['video_id'];

      /** SPA navigation to the next episode won't fire beforeunload/ngOnDestroy, so persist
       * the outgoing episode's analytics here before we switch videos. */
      if (isEpisodeSwitch && (this.player || this.ytPlayer) && this.videos && this.videos.videos) {
        try {
          const watchedTo = this.currentPlaybackTime();
          this.videoanalyticsSave(watchedTo, prevVideoId);
          this.videoWatchedDuration(watchedTo, this.videos.videos.seconds);
          this.watchTime.flush('video');
        } catch (e) {
          console.warn('analytics save on episode switch failed', e);
        }
      }

      this.fullParams = params;
      this.params = params['video_id'];

      /** First load is handled by ngOnInit(); only reload the player for subsequent
       * in-app navigations (next episode) so there is no full page reload. */
      if (isEpisodeSwitch) {
        this.loadNextVideo();
      }
    });

  }

  /** Reload the player for a new episode via SPA navigation (no full page reload).
   * Tears down the current videojs player + its manually-mounted DOM so nothing
   * duplicates, recreates a fresh <video>, then re-runs the same proven load path. */
  loadNextVideo() {
    this.watchTick = null;
    // Dispose the existing player (removes the <video> element it owned).
    try {
      if (this.player) {
        this.player.dispose();
      }
    } catch (e) {
      console.warn('player dispose on episode switch failed', e);
    }
    this.player = null;

    // Tear down the YouTube iframe (if the outgoing video was an embed) and reset the
    // embed state, so the next video is free to take either path.
    this.destroyYoutubePlayer();
    this.isYoutube = false;
    this.isVimeo = false;
    this.vimeoUrl = null;
    this.ytShowPoster = true;
    this.embedHovered = false;
    this.embedTitle = '';
    this.ytPoster = '';

    // initPlayer() appends custom buttons INTO these static divs; videojs dispose does
    // NOT clean them, so clear them here to avoid duplicate controls on each episode.
    ['center-button', 'back-top-button', 'email-container', 'forward-backword-button'].forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.innerHTML = '';
      }
    });

    // The SettingsButton component appends its menu/submenu to <body>; remove any leftovers.
    document.querySelectorAll('.vjs-settings-menu, .vjs-settings-submenu').forEach(el => {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    });

    // Drop any leftover <video>/videojs wrapper before recreating one. Normally dispose()
    // already removed it, but on a YouTube → non-YouTube switch videojs never owned the
    // template's element, so it is still sitting there and would end up duplicated.
    const staleVideos = this.playerHost.nativeElement.querySelectorAll('video, .video-js');
    for (let i = 0; i < staleVideos.length; i++) {
      const stale = staleVideos[i];
      if (stale.parentNode) {
        stale.parentNode.removeChild(stale);
      }
    }

    // Recreate the <video> element (videojs removed the previous one on dispose). It starts
    // hidden because it is a fixed, full-screen black box that would cover an embed player:
    // whichever path getVideos() picks decides its visibility (setVideojsElementHidden).
    const video = document.createElement('video');
    video.id = 'my-player';
    video.className = 'video-js vjs-default-skin vjs-big-cover embed-inactive';
    video.setAttribute('controls', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('crossorigin', 'anonymous');

    // Copy Angular's view-encapsulation attribute (_ngcontent-*) from a template element.
    // videojs copies the video's attributes onto its player wrapper, so this keeps the
    // scoped SCSS (#my-player.vjs-big-cover { width:100vw; height:100vh }) matching —
    // without it the freshly-created player renders at the tiny videojs default size.
    const hostEl = this.playerHost.nativeElement as HTMLElement;
    for (let i = 0; i < hostEl.attributes.length; i++) {
      const attrName = hostEl.attributes[i].name;
      if (attrName.indexOf('_ngcontent') === 0) {
        video.setAttribute(attrName, '');
        break;
      }
    }

    this.playerHost.nativeElement.appendChild(video);
    this.videoPlayer = new ElementRef(video);

    // Reset per-video UI state.
    this.showNextButton = false;
    this.nextEpisodeSlug = false;
    this.showPlayErrorPopup = false;
    this.titleComp = null;
    this.emailComp = null;
    this.isNavigatingNext = false;

    // Reset the "up next" auto-advance card for the new video (sibling of the player,
    // so player.dispose() does NOT remove it — take it out explicitly).
    if (this.nextUpOverlayEl && this.nextUpOverlayEl.parentNode) {
      this.nextUpOverlayEl.parentNode.removeChild(this.nextUpOverlayEl);
    }
    this.nextUpVideo = null;
    this.nextUpUrl = '';
    this.nextUpOverlayEl = null;
    this.nextUpCountEl = null;
    this.nextUpVisible = false;
    this.nextUpDismissed = false;

    // Reset related-videos card for the new video. It lives in playerHost (a sibling
    // of the player), so player.dispose() does NOT remove it — take it out explicitly.
    if (this.relatedOverlayEl && this.relatedOverlayEl.parentNode) {
      this.relatedOverlayEl.parentNode.removeChild(this.relatedOverlayEl);
    }
    this.relatedVideos = [];
    this.relatedOverlayEl = null;
    this.relatedOverlayVisible = false;
    this.relatedDismissed = false;

    // Reset the slide-in sidebar for the new video.
    this.showSidebar = false;
    this.sidebarVideos = [];

    // Re-run the same load path used on first load.
    this.checkSupportedDRM().then(() => {
      this.checkBrowser();
      setTimeout(() => {
        this.getVideos();
      }, 1);
    });
  }

  convertToSeconds(value: number | null | undefined): number {
    return value != null ? Math.floor(value * 60) : 0;
  }

  convertToMinutes(seconds?: number): number {
    return seconds != null ? Number((seconds / 60).toFixed(3)) : 0;
  }

  millisecondsToSeconds(ms: any) {
    return ms / 1000;
  }


  getVideos() {
    let url;
    url = 'v2/watchvideo/' + this.fullParams['video_id'];
    if (this.adminPlaylistSlug) {
      url += '?playlist_id=' + this.adminPlaylistSlug;
    }
    this.apiService.callGetAPI(url)
      .subscribe(
        async data => {


          if (data['statusCode'] === 200 && data['error'] === false) {
            this.videos = data['response'];

            // Shorts belong to ShortsPlayerComponent; WatchVideoComponent is already
            // redirecting there. Bail out before any playback starts, otherwise this
            // player keeps buffering (and audibly playing) the short behind the feed.
            if (Number(this.videos.videos.is_shorts) === 1) {
              this.setVideojsElementHidden(true);
              return;
            }

            // YouTube / Vimeo embeds have no HLS/DASH source — they play inside the
            // provider's own iframe, so they skip videojs/EME entirely. video_type 'VMO'
            // is a Vimeo link the admin pasted into embed_url; it has to be checked first
            // because watchvideo only returns is_vimeo for live videos, and the admin
            // stores VMO with is_embed = 1 (which alone would send it down the YouTube path).
            this.isVimeo = String(this.videos.videos.video_type || '').toUpperCase() === 'VMO'
              || parseInt(this.videos.videos.is_vimeo, 10) === 1;
            this.isYoutube = !this.isVimeo && parseInt(this.videos.videos.is_embed, 10) === 1;
            if (this.isEmbedPlayback) {
              // The videojs <video> is a fixed full-screen element — keep it out of the way
              // so it can't cover the provider's iframe.
              this.setVideojsElementHidden(true);
              if (!this.isBlockedByPaywall()) {
                this.currentVideos = this.videos;
                if (this.isYoutube) {
                  this.initYoutubePlayer();
                } else {
                  this.initVimeoPlayer();
                }
                this.setupNextInSequence(false); // no videojs control bar to hang a "next part" button on
              }
              this.navigateIfNotYetStarted();
              return;
            }

            this.setVideojsElementHidden(false);
            this.initPlayer();
            if (this.isBlockedByPaywall()) {
              return;
            }

            this.currentVideos = this.videos;
            this.player.currentTime(this.videos.videos.seconds);

            // Wires the slide-in sidebar (available anytime via the toggle button) and
            // whatever plays after this video.
            this.setupNextInSequence(true);

            if (this.titleComp) {
              this.titleComp.setTitle(this.videos.videos.title);
            }


            if (data['response'].videos.video_type === 'DRM') {
              this.drmType = this.videos.videos.token_type;
              this.dashUri = this.videos.videos.drm_dash_url;
              this.hlsUri = this.videos.videos.drm_hls_url;
              this.widevineToken = this.videos.videos.drm_token;
              this.fairplayToken = this.widevineToken; // Ensure FairPlay token is set
              this.playreadyToken = this.widevineToken; // Ensure PlayReady token is set


              // Only initialize player if URLs are available
              if (this.dashUri || this.hlsUri) {
                // Test FairPlay endpoints if FairPlay is supported
                if (this.drmType === 'FairPlay') {
                  const endpointsOk = await this.testFairPlayEndpoints();
                  if (!endpointsOk) {
                    console.warn('FairPlay endpoints test failed, but continuing with playback');
                  }

                  // Test SPC encoding
                  this.testSPCEncoding();

                  // Test license request
                  await this.testFairPlayLicenseRequest();
                }
                this.playVideo();
              } else {
                console.error('No valid video URL found');
              }
            } else {
              this.hlsUri = this.videos.videos.hls_playlist_url;
              this.playVideo();
            }
          }

          this.navigateIfNotYetStarted();
        },
        error => {
          if (this.fullParams['playlist_id'] !== undefined) {
            this.router.navigate(['video/' + this.fullParams['video_id'] + '/' + this.fullParams['playlist_id'] + '/' + this.fullParams['name']]);
          }
          if (error.status === 404) {
            this.router.navigate(['video-not-found']);
          } else {
            this.apiService.failureResponse(error);
          }
        });
  }

  /** Paid video + logged-in user without a subscription: show the subscribe popup (and a
   * "next part" link when there is one) and tell the caller not to start playback.
   * @returns true when playback must not start. */
  private isBlockedByPaywall(): boolean {
    if (!(this.videos.videos.price > 0 || this.videos.videos.is_premium !== 0)) {
      console.log("This is a not paid video. Please watch.");
      return false;
    }

    console.log("This is a paid video. Please purchase to watch.");
    const userValues = localStorage.getItem('currentUser');
    if (!userValues) {
      return false;
    }

    const userData = this.authService.decryption(userValues);
    console.log("userData['response']", userData['response']);
    if (userData['response'].is_subscribed != 0) {
      return false;
    }

    this.showPlayErrorPopup = true;
    if (this.videos && this.videos.videos && this.videos.videos.next_episode_slug && this.videos.videos.next_episode_slug.hls_playlist_url) {
      this.nextEpisodeSlug = true;
      this.playNextPartUrl = '/watch/' + this.videos.videos.next_episode_slug.slug;
    }
    return true;
  }

  /** True when this video was opened from a user playlist — watch/:slug/:playlist_id/:name.
   * That playlist, not the related-videos list, then decides what plays next. */
  get hasUserPlaylist(): boolean {
    return !!(this.fullParams && this.fullParams['playlist_id'] && this.fullParams['name']);
  }

  /** Route for the next thing to play, keeping the playlist context. Shorts resolve to
   * the vertical feed, everything else to this player. */
  private sequenceUrlFor(video: any): string {
    if (this.hasUserPlaylist) {
      return this.playQueue.pathFor(video, this.fullParams['playlist_id'], this.fullParams['name']);
    }
    return this.playQueue.pathFor(video);
  }

  /** Decide what follows this video and fill the sidebar.
   *
   * Inside a playlist the playlist owns the order — that is the whole point of playing
   * one — so it wins over the next web-series episode and over the related-videos list.
   * Everywhere else the previous behaviour stands.
   *
   * @param registerControlBarButton videojs-only — the embed path has no control bar. */
  private setupNextInSequence(registerControlBarButton: boolean) {
    if (this.hasUserPlaylist) {
      // The stored list still fills the sidebar; only the "what plays next" decision moves.
      this.getRelatedVideos(false);
      this.setupPlaylistUpNext(registerControlBarButton);
      return;
    }
    this.setupUpNext(registerControlBarButton);
    this.getRelatedVideos(!this.showNextButton);
  }

  /** Advance through the user playlist this video belongs to, whatever its entries are:
   * a short hands over to the shorts feed, a YouTube entry to the embed player, a normal
   * video to videojs — all without leaving the sequence. */
  private setupPlaylistUpNext(registerControlBarButton: boolean) {
    const playlistId = this.fullParams['playlist_id'];
    const playlistName = this.fullParams['name'];
    const slug = this.fullParams['video_id'];

    this.playQueue.ensure(playlistId, playlistName, slug).subscribe(queue => {
      // The queue may arrive from the network, by which time the user could have moved on.
      if (!this.fullParams || this.fullParams['video_id'] !== slug) {
        return;
      }

      if (queue && queue.autoPlay && !this.queueForcesAutoPlay) {
        this.queueForcesAutoPlay = true;
        this.autoPlayEnabled = true;
        this.refreshAutoPlayButton();
      }

      const next = queue ? this.playQueue.nextOf(queue.items, slug) : null;
      if (!next) {
        // End of the playlist (or nothing usable came back) — fall back to the normal
        // next-episode / related-video behaviour rather than dead-ending.
        this.setupUpNext(registerControlBarButton);
        if (!this.showNextButton) {
          this.getRelatedVideos(true);
        }
        return;
      }

      // The playlist is the real sequence, so it is also the better sidebar list.
      this.sidebarVideos = queue.items.filter(v => v.slug !== slug);

      this.nextUpVideo = next;
      this.nextUpUrl = this.playQueue.pathFor(next, queue.playlistId, queue.playlistName);
      this.showNextButton = true;
      if (registerControlBarButton && this.player) {
        this.registerCustomButtons(this.nextUpUrl); // 👈 next-part control-bar button
      }
      this.buildNextUpOverlay();

      // With auto_play off nothing advances on its own, so the end screen offers the
      // next playlist entry for a manual pick.
      this.relatedVideos = [next];
      this.buildRelatedOverlay();
    });
  }

  /** Work out what plays after this video (admin playlist entry or next web-series
   * episode) and build the "up next" countdown card for it.
   * @param registerControlBarButton videojs-only — the YouTube path has no control bar. */
  private setupUpNext(registerControlBarButton: boolean) {
    const nextPlaylistVideo = this.getNextPlaylistVideo();
    const nextEpisode = this.videos && this.videos.videos && this.videos.videos.next_episode_slug;
    if (nextPlaylistVideo && nextPlaylistVideo.slug) {
      // Admin playlist: auto-advance to the next entry in playlist_videos (by slug).
      this.nextUpVideo = nextPlaylistVideo;
      this.nextUpUrl = this.buildPlaylistWatchUrl(nextPlaylistVideo.slug);
    } else if (nextEpisode && nextEpisode.slug && (nextEpisode.hls_playlist_url || this.isEmbedPlayback)) {
      // Web-series: auto-advance to the next episode. (Embed episodes carry no HLS url.)
      this.nextUpVideo = nextEpisode;
      this.nextUpUrl = '/watch/' + nextEpisode.slug;
    }

    if (this.nextUpUrl) {
      this.showNextButton = true;
      if (registerControlBarButton) {
        this.registerCustomButtons(this.nextUpUrl); // 👈 next-part control-bar button
      }
      this.buildNextUpOverlay();                    // 👈 up-next card + countdown
    }
  }

  /** Videos scheduled to start later are not watchable yet — send the user back to the
   * detail page. @returns true when a navigation was triggered. */
  private navigateIfNotYetStarted(): boolean {
    const video = this.videos && this.videos.videos;
    if (!video) {
      return false;
    }
    if (video.scheduledStartTime !== '' && (video.scheduledStartTime > new Date().getTime())) {
      if (this.fullParams['playlist_id'] !== undefined) {
        this.router.navigate(['video/' + this.fullParams['video_id'] + '/' + this.fullParams['playlist_id'] + '/' + this.fullParams['name']]);
      } else {
        this.router.navigate(['video/' + this.fullParams['video_id']]);
      }
      return true;
    }
    return false;
  }

  ngOnInit() {

    this.currentDecryptUser = this.authService.decryption(
      localStorage.getItem('currentUser')
    );
    this.userId = this.currentDecryptUser.response.id;
    this.userName = this.currentDecryptUser.response.email.split('@')[0];
    if (this.userId === undefined) {
      this.apiService.callGetAPI(`v2/video/get_user_id`).subscribe(data => {
        this.userId = data['response'].user_id;
        this.userName = data['response'].email.split('@')[0];
      });
    }

    // Load the auto_play preference once. The component is reused across SPA episode
    // switches (ngOnInit does not re-run), so a single fetch here holds for the session.
    this.getAutoPlaySetting();

    // Switching tabs/windows sends the playing video to picture-in-picture.
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    this.checkSupportedDRM().then(() => {
      this.checkBrowser();
      setTimeout(() => {
        this.getVideos()
      }, 1)
    });
  }

  /** Fetch the customer's auto_play preference (v2/customer/subscription). auto_play === 1
   * enables auto-advancing to the next video; anything else stops playback at the end. */
  getAutoPlaySetting() {
    this.apiService.callGetAPI('v2/customer/subscription', environment.userApiUrl)
      .subscribe(
        data => {
          this.autoPlayEnabled = this.queueForcesAutoPlay || !!(data && data['response'] && data['response']['auto_play'] == 1);
          this.refreshAutoPlayButton();
        },
        error => {
          console.warn('auto_play setting fetch failed; defaulting to no auto-advance', error);
          this.autoPlayEnabled = this.queueForcesAutoPlay;
          this.refreshAutoPlayButton();
        });
  }

  /** Flip the auto_play preference from the settings-menu toggle: optimistically update
   * the UI, then persist to the notification settings API (auto_play 0/1). Reverts the
   * toggle if the API call fails. */
  toggleAutoPlay() {
    // An explicit choice beats the queue's forced auto-advance from here on.
    this.queueForcesAutoPlay = false;
    const next = !this.autoPlayEnabled;
    this.autoPlayEnabled = next;
    this.refreshAutoPlayButton();

    this.apiService.callPostAPI('v2/notification/settings',
      { auto_play: next ? 1 : 0 }, environment.notificationApiUrl)
      .subscribe(
        () => {
          localStorage.setItem('autoPlay', JSON.stringify(next));
        },
        error => {
          console.warn('auto_play update failed; reverting toggle', error);
          this.autoPlayEnabled = !next;
          this.refreshAutoPlayButton();
        });
  }

  /** The underlying <video> element videojs is driving (null before/after the player exists). */
  private getVideoEl(): any {
    if (!this.player || typeof this.player.el !== 'function') return null;
    const el = this.player.el();
    return el ? el.querySelector('video') : null;
  }

  /** Tab/window switch → float the playing video into picture-in-picture so it stays
   * visible. Coming back does NOT close it immediately: Chrome only allows
   * requestPictureInPicture() from a user gesture *or* when something is already in PiP,
   * so keeping the window open is what makes every later tab switch work. It collapses
   * back inline on the user's first click/keypress on the page instead. */
  private handleVisibilityChange() {
    const video = this.getVideoEl();
    if (!video) return;

    if (document.visibilityState === 'hidden') {
      // Tab going to background may be the last we hear from it — checkpoint now.
      this.watchTime.flush('video');
      this.disarmPipExitGesture();
      this.enterAutoPip(video);
    } else if (this.pipAutoEntered) {
      this.armPipExitGesture();
    }
  }

  /** Wait for the user to actually interact with this tab, then pull PiP back inline. */
  private armPipExitGesture() {
    if (this.pipExitGestureArmed) return;
    this.pipExitGestureArmed = true;
    // Capture phase + no preventDefault: the click still reaches the player as usual.
    document.addEventListener('pointerdown', this.onPipExitGesture, true);
    document.addEventListener('keydown', this.onPipExitGesture, true);
  }

  private disarmPipExitGesture() {
    if (!this.pipExitGestureArmed) return;
    this.pipExitGestureArmed = false;
    document.removeEventListener('pointerdown', this.onPipExitGesture, true);
    document.removeEventListener('keydown', this.onPipExitGesture, true);
  }

  /** Best-effort PiP entry. Browsers normally want a recent user gesture for
   * requestPictureInPicture(), so a refusal is expected sometimes and just logged. */
  private enterAutoPip(video: any) {
    const doc: any = document;

    if (doc.pictureInPictureElement) return;          // already floating
    if (video.paused || video.ended) return;          // nothing worth floating
    if (video.disablePictureInPicture) return;
    // Fullscreen already collapses on tab switch; don't fight it.
    if (doc.fullscreenElement || doc.webkitFullscreenElement) return;

    // Safari exposes presentation modes instead of the standard PiP API.
    if (!doc.pictureInPictureEnabled && typeof video.webkitSetPresentationMode === 'function') {
      try {
        video.webkitSetPresentationMode('picture-in-picture');
        this.pipAutoEntered = true;
      } catch (error) {
        console.warn('auto picture-in-picture blocked', error);
      }
      return;
    }

    if (!doc.pictureInPictureEnabled || typeof video.requestPictureInPicture !== 'function') return;

    video.requestPictureInPicture()
      .then(() => {
        this.pipAutoEntered = true;
        // The user can close the PiP window themselves — forget it once it's gone.
        video.addEventListener('leavepictureinpicture', this.onLeavePip, { once: true });
      })
      .catch(error => {
        console.warn('auto picture-in-picture blocked', error);
      });
  }

  /** Undo an auto-entered PiP. A PiP the user opened via the control bar is left alone. */
  private exitAutoPip() {
    if (!this.pipAutoEntered) return;
    this.pipAutoEntered = false;

    const doc: any = document;
    if (doc.pictureInPictureElement) {
      doc.exitPictureInPicture().catch(error => {
        console.warn('exit picture-in-picture failed', error);
      });
      return;
    }

    const video = this.getVideoEl();
    if (video && video.webkitPresentationMode === 'picture-in-picture' &&
        typeof video.webkitSetPresentationMode === 'function') {
      try {
        video.webkitSetPresentationMode('inline');
      } catch (error) {
        console.warn('exit picture-in-picture failed', error);
      }
    }
  }

  /** Re-render the settings-menu Autoplay switch to match the current auto_play state. */
  refreshAutoPlayButton() {
    if (this.settingsBtn && typeof this.settingsBtn.refreshAutoPlay === 'function') {
      this.settingsBtn.refreshAutoPlay();
    }
  }

  plainText: any;
  cipherText: any;


  binaryToHex(num) {
    let str = '',
      i = 0;
    const tmp_len = num.length;
    let c;
    for (; i < tmp_len; i += 1) {
      c = num.charCodeAt(i);
      str += this.d2h(c);
    }
    return str;
    // return parseInt(num, 2).toString(16);
  }
  d2h(d) {
    return d.toString(16);
  }

  addSubtitlesToPlayer() {
    if (!this.player) return;

    const tracks = this.getSubtitleTracks();
    if (!tracks.length) return;

    tracks.forEach(track => {
      this.player.addRemoteTextTrack(track, false);
    });

    const textTracks = this.player.textTracks();

    for (let i = 0; i < textTracks.length; i++) {
      textTracks[i].mode = 'hidden';
    }

    for (let i = 0; i < textTracks.length; i++) {
      if (textTracks[i].kind === 'captions') {
        textTracks[i].mode = 'showing';
      }
    }

    console.log('✅ Captions enabled:', textTracks.length);
  }


  getSubtitleTracks() {
    if (this.videos && this.videos.videos && this.videos.videos.subtitle && this.videos.videos.subtitle.subtitle_list && this.videos.videos.subtitle.subtitle_list.length) {
      const subtitle = this.videos.videos.subtitle;
      return subtitle.subtitle_list.map(sub => ({
        kind: 'captions',
        src: subtitle.base_url + sub.url,
        srclang: sub.language,
        label: sub.label,
        default: true
      }));
    } else {
      return [];
    }
  }

  encrypt() {
    const utf8 = CryptoJS.enc.Utf8.parse('vplayed/' + this.plainText);
    const hex_utf = utf8.toString(CryptoJS.enc.Utf8);
    const hex = this.binaryToHex(hex_utf);
    this.encrypted = CryptoJS.AES.encrypt(
      hex,
      CryptoJS.enc.Hex.parse(environment.crypto_key),
      {
        keySize: 256,
        iv: CryptoJS.enc.Hex.parse(environment.crypto_iv),
        mode: CryptoJS.mode.CBC
      }
    );
    this.cipherText = this.encrypted.ciphertext.toString(CryptoJS.enc.utf8);
    return this.cipherText;
  }

  ngAfterViewInit(): void {

  }

  initPlayer(){

    const Component = videojs.getComponent('Component');
    class CenterBackwardButton extends Component {

      constructor(player: any, options: any) {
        super(player, options);

        const el = this.el();
        el.className = 'vjs-center-backward-button';

        el.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="white" width="40" height="40">
            <path d="M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
            <text x="12" y="16" text-anchor="middle"
                  font-size="6" font-weight="bold">10</text>
          </svg>
        `;

        el.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();

          const currentTime = player.currentTime();
          player.currentTime(Math.max(0, currentTime - 10));
        });
      }

      createEl() {
        return videojs.dom.createEl('div');
      }
    }
    class CenterForwardButton extends Component {

      constructor(player: any, options: any) {
        super(player, options);

        const el = this.el();
        el.className = 'vjs-center-forward-button';

        el.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="white" width="40" height="40">
            <path d="M12 5V1l5 5-5 5V7c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6h2c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8z"/>
            <text x="12" y="16" text-anchor="middle"
                  font-size="6" font-weight="bold">10</text>
          </svg>
        `;

        el.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();

          const currentTime = player.currentTime();
          const duration = player.duration();
          player.currentTime(Math.min(duration, currentTime + 10));
        });
      }

      createEl() {
        return videojs.dom.createEl('div');
      }
    }
    class CenterToggleButton extends Component {

      constructor(player: any, options: any) {
        super(player, options);

        const el = this.el();
        el.className = 'vjs-center-toggle-button';

        el.innerHTML = `
          <img class="play-pause-icon"
              src="../../../assets/images/play_icon.png"
              alt="Play/Pause"
              width="40"
              height="40" />
        `;

        const icon = el.querySelector('.play-pause-icon') as HTMLImageElement;

        // Toggle play / pause on click
        el.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();

          if (player.paused()) {
            player.play();
          } else {
            player.pause();
          }
        });

        // Update icon when player state changes
        player.on('play', () => {
          icon.src = '../../../assets/images/paused_icon.png';
        });

        player.on('pause', () => {
          icon.src = '../../../assets/images/play_icon.png';
        });
      }

      createEl() {
        return videojs.dom.createEl('div', {
          className: 'vjs-center-toggle-button'
        });
      }
    }
    class CenterCustomizeButton extends Component {
      private titleEl: HTMLElement | null = null;
      private PageBack?: () => void;

      constructor(player: any, options: any) {
        super(player, options);
        this.PageBack = options.pageBack;

        const el = this.el();
        el.className = 'vjs-center-customize-button';

        el.innerHTML = `
          <div class="movie-title title-grd">
            <div class="backbutton">
              <svg xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="20"
                height="20"
                fill="#FFFFFF">
                <path d="M501.333 245.333H36.417l141.792-141.792c4.167-4.167 4.167-10.917 0-15.083-4.167-4.167-10.917-4.167-15.083 0l-160 160c-4.167 4.167-4.167 10.917 0 15.083l160 160c4.167 4.167 10.917 4.167 15.083 0 4.167-4.167 4.167-10.917 0-15.083L36.417 266.667h464.917c5.896 0 10.667-4.771 10.667-10.667s-4.771-10.667-10.667-10.667z"/>
              </svg>
            </div>
            <h2 class="video-name-back-button"></h2>
          </div>
        `;

        this.titleEl = el.querySelector('.video-name-back-button');

        // initial title
        this.setTitle(options.title || '');

        const backBtn = el.querySelector('.backbutton') as HTMLElement | null;

        if (backBtn) {
          backBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.PageBack) {
              this.PageBack();
            }
            console.log('Back clicked');
          });
        }
      }

      /** 🔹 Public method to update title anytime */
      setTitle(title: string) {
        if (this.titleEl) {
          this.titleEl.textContent = title;
        }
      }

      createEl() {
        return videojs.dom.createEl('div');
      }
    }
    class CenterEmailText extends Component {
      private emailEl: HTMLElement | null = null;

      constructor(player: any, options: any) {
        super(player, options);

        const el = this.el();
        el.className = 'vjs-center-email-text';

        el.innerHTML = `
          <div class="email-text-container">
            <h2 class="email-text"></h2>
          </div>
        `;

        this.emailEl = el.querySelector('.email-text');

        const email =
          options && options.email
            ? options.email
            : '';

        this.setEmail(email);
      }

      setEmail(email: string) {
        if (this.emailEl) {
          this.emailEl.textContent = email;
        }
      }

      createEl() {
        return videojs.dom.createEl('div');
      }
    }

    class FastForwardButton extends Component {
      private intervalId: any = null;
      private timeEl!: HTMLElement;

      constructor(player: any, options: any) {
        super(player, options);

        const el = this.el();
        el.className = 'vjs-center-fast-button';

        el.innerHTML = `
          <div class="fast-forward-button">
            <div class="time-text">0:00</div>
          </div>
        `;

        const btn = el.querySelector('.fast-forward-button') as HTMLElement;
        this.timeEl = btn.querySelector('.time-text') as HTMLElement;

        /* 🔹 hide initially */
        this.hideTime();

        /* ---- seek logic ---- */
        const seekForward = () => {
          const currentTime = player.currentTime();
          const duration = player.duration();
          player.currentTime(Math.min(duration, currentTime - 20));
        };

        /* ---- single click ---- */
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          seekForward();
        });

        /* ---- long press start ---- */
        const startPress = (e: Event) => {
          e.preventDefault();
          e.stopPropagation();

          this.showTime();
          seekForward();
          this.intervalId = setInterval(seekForward, 500);
        };

        /* ---- long press end ---- */
        const endPress = () => {
          this.hideTime();
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
        };

        /* ---- mouse (only press) ---- */
        btn.addEventListener('mousedown', startPress);
        btn.addEventListener('mouseup', endPress);
        btn.addEventListener('mouseleave', endPress);

        /* ---- touch (only press) ---- */
        btn.addEventListener('touchstart', startPress);
        btn.addEventListener('touchend', endPress);
        btn.addEventListener('touchcancel', endPress);

        /* ---- live time update ---- */
        player.on('timeupdate', () => {
          this.timeEl.textContent = this.formatTime(player.currentTime());
        });
      }

      private showTime() {
        this.timeEl.style.opacity = '1';
      }

      private hideTime() {
        this.timeEl.style.opacity = '0';
      }

      private formatTime(seconds: number): string {
        const m = Math.floor(seconds / 60);
        const s = Math.floor(seconds % 60);
        return `${m}:${s < 10 ? '0' + s : s}`;
      }

      createEl() {
        return videojs.dom.createEl('div');
      }
    }

    class FastBackwardButton extends Component {
      private intervalId: any = null;
      private timeEl!: HTMLElement;

      constructor(player: any, options: any) {
        super(player, options);

        const el = this.el();
        el.className = 'vjs-center-back-button';

        el.innerHTML = `
          <div class="fast-backward-button">
            <div class="time-text">0:00</div>
          </div>
        `;

        const btn = el.querySelector('.fast-backward-button') as HTMLElement;
        this.timeEl = btn.querySelector('.time-text') as HTMLElement;

        /* 🔹 Hide initially */
        this.hideTime();

        /* ---- seek logic ---- */
        const seekBackward = () => {
          const currentTime = player.currentTime();
          player.currentTime(Math.max(0, currentTime + 20));
        };

        /* ---- single click ---- */
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          seekBackward();
        });

        /* ---- long press start ---- */
        const startPress = (e: Event) => {
          e.preventDefault();
          e.stopPropagation();

          this.showTime();
          seekBackward();
          this.intervalId = setInterval(seekBackward, 500);
        };

        /* ---- long press end ---- */
        const endPress = () => {
          this.hideTime();
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
        };

        /* ---- mouse (ONLY press) ---- */
        btn.addEventListener('mousedown', startPress);
        btn.addEventListener('mouseup', endPress);
        btn.addEventListener('mouseleave', endPress);

        /* ---- touch (ONLY press) ---- */
        btn.addEventListener('touchstart', startPress);
        btn.addEventListener('touchend', endPress);
        btn.addEventListener('touchcancel', endPress);

        /* ---- live time update ---- */
        player.on('timeupdate', () => {
          this.timeEl.textContent = this.formatTime(player.currentTime());
        });
      }

      private showTime() {
        this.timeEl.style.opacity = '1';
      }

      private hideTime() {
        this.timeEl.style.opacity = '0';
      }

      private formatTime(seconds: number): string {
        const m = Math.floor(seconds / 60);
        const s = Math.floor(seconds % 60);
        return `${m}:${s < 10 ? '0' + s : s}`;
      }

      createEl() {
        return videojs.dom.createEl('div');
      }
    }

    // const Component = videojs.getComponent('Component');

    class SettingsButton extends Component {
      private menu!: HTMLElement;
      private subMenu!: HTMLElement;
      private hideTimer: any = null;
      private isHoveringMenu: boolean = false;
      private keepAliveTimer: any = null;
      /** auto_play preference state/behaviour, supplied via options so the class
       * (registered once) never captures a stale value. */
      private getAutoPlay: () => boolean = () => false;
      private onToggleAutoPlay: () => void = () => {};

      constructor(player: any, options: any) {
        super(player, options);

        this.getAutoPlay = options.getAutoPlay || (() => false);
        this.onToggleAutoPlay = options.onToggleAutoPlay || (() => {});

        const el = this.el();
        el.className = 'vjs-settings-button';

        el.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
           viewBox="0 0 24 24" fill="white">
        <path d="M19.14,12.94a7.14,7.14,0,0,0,.05-.94,7.14,7.14,0,0,0-.05-.94l2.11-1.65a.5.5,0,0,0,.12-.65l-2-3.46a.5.5,0,0,0-.6-.22l-2.49,1a7.28,7.28,0,0,0-1.63-.94l-.38-2.65A.5.5,0,0,0,13.78,2H10.22a.5.5,0,0,0-.49.42L9.35,5.07a7.28,7.28,0,0,0-1.63.94l-2.49-1a.5.5,0,0,0-.6.22l-2,3.46a.5.5,0,0,0,.12.65L4.86,11.06a7.14,7.14,0,0,0-.05.94,7.14,7.14,0,0,0,.05.94L2.75,14.59a.5.5,0,0,0-.12.65l2,3.46a.5.5,0,0,0,.6.22l2.49-1a7.28,7.28,0,0,0,1.63.94l.38,2.65a.5.5,0,0,0,.49.42h3.56a.5.5,0,0,0,.49-.42l.38-2.65a7.28,7.28,0,0,0,1.63-.94l2.49,1a.5.5,0,0,0,.6-.22l2-3.46a.5.5,0,0,0-.12-.65ZM12,15.5A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"/>
      </svg>
    `;

        this.createMenu();

        const keepAlive = () => {
          this.isHoveringMenu = true;
          (this.player() as any).userActive(true);
          // The menu lives on document.body, so mousemoves over it never reach the
          // player element — videojs' inactivity timer would still fire and hide the
          // control bar. Keep re-asserting "active" while the pointer is on the menu.
          if (!this.keepAliveTimer) {
            this.keepAliveTimer = setInterval(() => {
              if (this.isHoveringMenu) {
                (this.player() as any).userActive(true);
              }
            }, 800);
          }
        };

        const allowHide = () => {
          this.isHoveringMenu = false;
          if (this.keepAliveTimer) {
            clearInterval(this.keepAliveTimer);
            this.keepAliveTimer = null;
          }
          setTimeout(() => {
            if (!this.isHoveringMenu) {
              (this.player() as any).userActive(false);
            }
          }, 2000);
        };

        el.addEventListener('mouseenter', () => {
          this.showMenu();
          keepAlive();
        });

        el.addEventListener('mouseleave', () => {
          this.scheduleHide();
          allowHide();
        });

        this.menu.addEventListener('mouseenter', () => {
          this.cancelHide();
          keepAlive();
        });

        this.menu.addEventListener('mouseleave', () => {
          this.scheduleHide();
          allowHide();
        });

        this.subMenu.addEventListener('mouseenter', () => {
          this.cancelHide();
          keepAlive();
        });

        this.subMenu.addEventListener('mouseleave', () => {
          this.scheduleHide();
          allowHide();
        });

        document.addEventListener('fullscreenchange', () => {
          this.onFullscreenChange();
        });

      }

      onFullscreenChange() {
        const playerEl = this.player().el();
        const doc: any = document;
        const isFs = !!(
          doc.fullscreenElement ||
          doc.webkitFullscreenElement ||
          doc.mozFullScreenElement ||
          doc.msFullscreenElement
        );


        const targetParent = isFs ? playerEl : document.body;

        if (this.menu.parentElement !== targetParent) {
          targetParent.appendChild(this.menu);
        }

        if (this.subMenu.parentElement !== targetParent) {
          targetParent.appendChild(this.subMenu);
        }

        // Force layout refresh → fixes dead click issue
        this.menu.style.display = 'none';
        this.menu.offsetHeight; // reflow trigger
        this.menu.style.display = '';

        this.subMenu.style.display = 'none';
        this.subMenu.offsetHeight;
        this.subMenu.style.display = '';
      }

      createMenu() {
        this.menu = document.createElement('div');
        this.menu.className = 'vjs-settings-menu vjs-hidden';

        this.subMenu = document.createElement('div');
        this.subMenu.className = 'vjs-settings-submenu vjs-hidden';

        this.renderMainMenu();

        document.body.appendChild(this.menu);
        document.body.appendChild(this.subMenu);
      }

      renderMainMenu() {
        this.menu.innerHTML = `
      <div class="vjs-settings-title">Settings</div>

      <div class="vjs-settings-item has-child" data-type="quality">Quality <span>›</span></div>
      <div class="vjs-settings-item has-child" data-type="speed">Speed <span>›</span></div>
      <div class="vjs-settings-item has-child" data-type="audio">Audio <span>›</span></div>
      <div class="vjs-settings-item has-child" data-type="subtitle">Subtitles <span>›</span></div>

      <div class="vjs-settings-divider"></div>

      <div class="vjs-settings-item vjs-settings-toggle" data-toggle="autoplay">
        <span>Autoplay</span>
        <span class="vjs-toggle-switch"><span class="vjs-toggle-knob"></span></span>
      </div>

      <div class="vjs-settings-divider"></div>

      <div class="vjs-settings-item action-btn" data-action="fullscreen">Fullscreen</div>
      <div class="vjs-settings-item action-btn" data-action="pip">Pip</div>

      <div class="vjs-settings-divider"></div>

      <div class="vjs-settings-transport">
        <button data-action="back">⏪</button>
        <button data-action="play">▶️</button>
        <button data-action="forward">⏩</button>
      </div>
    `;

        this.menu.querySelectorAll('.has-child').forEach((el: any) => {
          el.onclick = () => this.openSubMenu(el.dataset.type);
        });

        this.menu.querySelectorAll('.action-btn').forEach((el: any) => {
          el.onclick = () => this.handleAction(el.dataset.action);
        });

        this.menu.querySelectorAll('.vjs-settings-transport button').forEach((el: any) => {
          el.onclick = () => this.handleTransport(el.dataset.action);
        });

        const autoPlayRow = this.menu.querySelector('[data-toggle="autoplay"]') as HTMLElement;
        if (autoPlayRow) {
          // Keep the menu open — the switch flips in place once the API call resolves.
          autoPlayRow.onclick = () => this.onToggleAutoPlay();
        }
        this.refreshAutoPlay();
      }

      /** Re-render the Autoplay switch to reflect the current auto_play state. */
      refreshAutoPlay() {
        const sw = this.menu.querySelector('[data-toggle="autoplay"] .vjs-toggle-switch') as HTMLElement;
        if (!sw) return;
        sw.classList.toggle('on', !!this.getAutoPlay());
      }

      openSubMenu(type: string) {
        this.subMenu.innerHTML = `<div class="vjs-settings-title back">‹ Back</div>`;

        const backBtn = this.subMenu.querySelector('.back') as HTMLElement;
        backBtn.onclick = () => {
          this.subMenu.classList.add('vjs-hidden');
          this.menu.classList.remove('vjs-hidden');
        };

        if (type === 'quality') this.renderQualityMenu();
        if (type === 'speed') this.renderSpeedMenu();
        if (type === 'audio') this.renderAudioMenu();
        if (type === 'subtitle') this.renderSubtitleMenu();

        this.subMenu.style.height = this.menu.offsetHeight + 'px';

        this.menu.classList.add('vjs-hidden');
        this.subMenu.classList.remove('vjs-hidden');
      }

      renderQualityMenu() {
        const player: any = this.player();
        if (!player || !player.qualityLevels) return;

        const ql = player.qualityLevels();

        // Count how many levels are enabled → all enabled means we're in "Auto" mode,
        // a single enabled level means the user picked that specific resolution.
        let enabledCount = 0;
        for (let i = 0; i < ql.length; i++) {
          if (ql[i].enabled) enabledCount++;
        }
        const isAuto = enabledCount !== 1;

        const auto = document.createElement('div');
        auto.className = 'vjs-settings-item';
        // In Auto mode, show the resolution that is actually playing right now.
        const activeLevel = ql.selectedIndex >= 0 ? ql[ql.selectedIndex] : null;
        auto.innerHTML = isAuto && activeLevel && activeLevel.height
          ? `<span>Auto <small>(${activeLevel.height}p)</small></span>`
          : `<span>Auto</span>`;
        if (isAuto) auto.classList.add('vjs-selected');
        auto.onclick = () => {
          for (let i = 0; i < ql.length; i++) ql[i].enabled = true;
          this.closeMenus();
        };
        this.subMenu.appendChild(auto);

        for (let i = 0; i < ql.length; i++) {
          const q = ql[i];
          if (q.height) {
            const item = document.createElement('div');
            item.className = 'vjs-settings-item';
            item.innerHTML = `<span>${q.height}p</span>`;
            // A specific resolution is "selected" only when it is the single enabled level.
            if (!isAuto && q.enabled) item.classList.add('vjs-selected');
            item.onclick = () => {
              for (let j = 0; j < ql.length; j++) ql[j].enabled = false;
              q.enabled = true;
              this.closeMenus();
            };
            this.subMenu.appendChild(item);
          }
        }
      }

      renderSpeedMenu() {
        const currentRate = this.player().playbackRate();
        [0.5, 1, 1.25, 1.5, 2].forEach(sp => {
          const item = document.createElement('div');
          item.className = 'vjs-settings-item';
          item.innerHTML = `<span>${sp}x</span>`;
          if (sp === currentRate) item.classList.add('vjs-selected');
          item.onclick = () => {
            this.player().playbackRate(sp);
            this.closeMenus();
          };
          this.subMenu.appendChild(item);
        });
      }

      renderAudioMenu() {
        const tracks = this.player().audioTracks();
        for (let i = 0; i < tracks.length; i++) {
          const t = tracks[i];
          const item = document.createElement('div');
          item.className = 'vjs-settings-item';
          item.textContent = t.label || 'Track ' + (i + 1);
          item.onclick = () => {
            for (let j = 0; j < tracks.length; j++) tracks[j].enabled = false;
            t.enabled = true;
            this.closeMenus();
          };
          this.subMenu.appendChild(item);
        }
      }

      renderSubtitleMenu() {
        const tracks = this.player().textTracks();

        // Collect only real subtitle/caption tracks.
        const subs: any[] = [];
        for (let i = 0; i < tracks.length; i++) {
          if (tracks[i].kind === 'subtitles' || tracks[i].kind === 'captions') {
            subs.push(tracks[i]);
          }
        }

        // No subtitles for this video → show the recommended "not available" fallback.
        if (!subs.length) {
          const none = document.createElement('div');
          none.className = 'vjs-settings-item vjs-settings-disabled';
          none.innerHTML = `<span>No subtitles available</span>`;
          this.subMenu.appendChild(none);
          return;
        }

        // Is any subtitle currently visible?
        const isOn = subs.some(t => t.mode === 'showing');

        // On/Off toggle row.
        const toggle = document.createElement('div');
        toggle.className = 'vjs-settings-item vjs-settings-toggle';
        toggle.innerHTML = `
          <span>Subtitles</span>
          <span class="vjs-toggle-switch ${isOn ? 'on' : ''}"><span class="vjs-toggle-knob"></span></span>
        `;
        toggle.onclick = () => {
          const nowOn = subs.some(t => t.mode === 'showing');
          subs.forEach(t => t.mode = 'hidden');
          if (!nowOn) {
            // Turn on: prefer the default track, else the first one.
            (subs.find(t => t.default) || subs[0]).mode = 'showing';
          }
          // Re-render so the switch (and any language highlight) reflects the new state.
          this.openSubMenu('subtitle');
        };
        this.subMenu.appendChild(toggle);

        // More than one language → let the user pick which one, with the active one ticked.
        if (subs.length > 1) {
          subs.forEach((t, i) => {
            const item = document.createElement('div');
            item.className = 'vjs-settings-item';
            item.innerHTML = `<span>${t.label || 'Subtitle ' + (i + 1)}</span>`;
            if (t.mode === 'showing') item.classList.add('vjs-selected');
            item.onclick = () => {
              subs.forEach(s => s.mode = 'hidden');
              t.mode = 'showing';
              this.closeMenus();
            };
            this.subMenu.appendChild(item);
          });
        }
      }

      handleAction(type: string) {
        const player: any = this.player();

        if (type === 'fullscreen') {
          player.isFullscreen() ? player.exitFullscreen() : player.requestFullscreen();
        }

        if (type === 'pip') {
          const video = player.el().querySelector('video');
          if ((document as any).pictureInPictureElement) {
            (document as any).exitPictureInPicture();
          } else if (video) {
            video.requestPictureInPicture();
          }
        }

        this.closeMenus();
      }

      handleTransport(type: string) {
        const player: any = this.player();

        if (type === 'back') {
          player.currentTime(Math.max(0, player.currentTime() - 10));
        }

        if (type === 'forward') {
          player.currentTime(player.currentTime() + 10);
        }

        if (type === 'play') {
          player.paused() ? player.play() : player.pause();
        }
      }

      showMenu() {
        this.cancelHide();
        this.menu.classList.remove('vjs-hidden');
      }

      /** Click-driven open/close — used by the floating overlay gear, which has no
       * hover affordance on touch devices. */
      toggleMenu() {
        if (this.menu.classList.contains('vjs-hidden')) {
          this.showMenu();
        } else {
          this.closeMenus();
        }
      }

      scheduleHide() {
        this.cancelHide();
        this.hideTimer = setTimeout(() => {
          this.closeMenus();
        }, 300);
      }

      cancelHide() {
        if (this.hideTimer) {
          clearTimeout(this.hideTimer);
          this.hideTimer = null;
        }
      }

      closeMenus() {
        this.menu.classList.add('vjs-hidden');
        this.subMenu.classList.add('vjs-hidden');
      }

      createEl() {
        return videojs.dom.createEl('div', {
          className: 'vjs-control vjs-button'
        });
      }
    }

    /** YouTube-style floating control row (volume / CC / settings) drawn straight over
     * the video, matching the three buttons the YouTube embed shows. Registered as a
     * videojs component — not Angular markup — so it stays inside the player element
     * and keeps working in fullscreen; CSS ties its visibility to the user-active state. */
    class OverlayControls extends Component {
      private volumeBtn: HTMLElement | null = null;
      private ccBtn: HTMLElement | null = null;
      private onSettings: () => void = () => {};
      /** Re-applied on every text-track change so the CC button mirrors the real state. */
      private onTextTracksChange = () => this.refreshCaptions();
      private onVolumeChange = () => this.refreshVolume();

      constructor(player: any, options: any) {
        super(player, options);

        this.onSettings = options.onSettings || (() => {});

        const el = this.el();
        el.className = 'vjs-overlay-controls';
        el.innerHTML = `
      <button type="button" class="vjs-overlay-btn vjs-overlay-volume" aria-label="Mute"></button>

      <button type="button" class="vjs-overlay-btn vjs-overlay-cc" aria-label="Subtitles">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <rect x="2.6" y="5" width="18.8" height="14" rx="3.2"
                stroke="currentColor" stroke-width="1.8"/>
          <path d="M10.2 10.5a2.1 2.1 0 0 0-1.7-.9 2.4 2.4 0 0 0 0 4.8 2.1 2.1 0 0 0 1.7-.9
                   M16.8 10.5a2.1 2.1 0 0 0-1.7-.9 2.4 2.4 0 0 0 0 4.8 2.1 2.1 0 0 0 1.7-.9"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>

      <button type="button" class="vjs-overlay-btn vjs-overlay-settings" aria-label="Settings">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.14,12.94a7.14,7.14,0,0,0,.05-.94,7.14,7.14,0,0,0-.05-.94l2.11-1.65a.5.5,0,0,0,.12-.65l-2-3.46a.5.5,0,0,0-.6-.22l-2.49,1a7.28,7.28,0,0,0-1.63-.94l-.38-2.65A.5.5,0,0,0,13.78,2H10.22a.5.5,0,0,0-.49.42L9.35,5.07a7.28,7.28,0,0,0-1.63.94l-2.49-1a.5.5,0,0,0-.6.22l-2,3.46a.5.5,0,0,0,.12.65L4.86,11.06a7.14,7.14,0,0,0-.05.94,7.14,7.14,0,0,0,.05.94L2.75,14.59a.5.5,0,0,0-.12.65l2,3.46a.5.5,0,0,0,.6.22l2.49-1a7.28,7.28,0,0,0,1.63.94l.38,2.65a.5.5,0,0,0,.49.42h3.56a.5.5,0,0,0,.49-.42l.38-2.65a7.28,7.28,0,0,0,1.63-.94l2.49,1a.5.5,0,0,0,.6-.22l2-3.46a.5.5,0,0,0-.12-.65ZM12,15.5A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"/>
        </svg>
      </button>
    `;

        this.volumeBtn = el.querySelector('.vjs-overlay-volume');
        this.ccBtn = el.querySelector('.vjs-overlay-cc');
        const settingsBtnEl = el.querySelector('.vjs-overlay-settings') as HTMLElement | null;

        // The player element toggles play/pause on click — keep those clicks on the buttons.
        if (this.volumeBtn) {
          this.volumeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleMute();
          });
        }

        if (this.ccBtn) {
          this.ccBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleCaptions();
          });
        }

        if (settingsBtnEl) {
          settingsBtnEl.addEventListener('click', (e) => {
            e.stopPropagation();
            this.onSettings();
          });
        }

        player.on('volumechange', this.onVolumeChange);
        // Subtitles are attached after the manifest loads, so watch the list itself too.
        player.on('texttrackchange', this.onTextTracksChange);
        player.on('loadeddata', this.onTextTracksChange);
        const tracks: any = player.textTracks();
        if (tracks && tracks.addEventListener) {
          tracks.addEventListener('addtrack', this.onTextTracksChange);
          tracks.addEventListener('removetrack', this.onTextTracksChange);
        }

        this.refreshVolume();
        this.refreshCaptions();
      }

      toggleMute() {
        const player: any = this.player();
        const unmuting = player.muted();
        player.muted(!unmuting);
        // Autoplay starts muted with volume possibly at 0 — unmuting to silence reads as broken.
        if (unmuting && player.volume() === 0) {
          player.volume(1);
        }
      }

      /** Enable the first subtitle/caption track, or turn every one of them off. */
      toggleCaptions() {
        const list = this.captionTracks();
        if (!list.length) return;

        const anyShowing = list.some(t => t.mode === 'showing');
        list.forEach((t, i) => {
          t.mode = (!anyShowing && i === 0) ? 'showing' : 'disabled';
        });

        this.refreshCaptions();
      }

      private captionTracks(): any[] {
        const tracks: any = this.player().textTracks();
        const list: any[] = [];
        for (let i = 0; i < tracks.length; i++) {
          if (tracks[i].kind === 'subtitles' || tracks[i].kind === 'captions') {
            list.push(tracks[i]);
          }
        }
        return list;
      }

      private refreshVolume() {
        if (!this.volumeBtn) return;
        const player: any = this.player();
        const muted = player.muted() || player.volume() === 0;

        this.volumeBtn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
        this.volumeBtn.classList.toggle('is-muted', muted);
        this.volumeBtn.innerHTML = muted
          ? `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
               <path d="M16.5,12A4.5,4.5,0,0,0,14,7.97v2.21l2.45,2.45A4.75,4.75,0,0,0,16.5,12ZM19,12a6.94,6.94,0,0,1-.54,2.64l1.51,1.51A8.8,8.8,0,0,0,21,12a8.99,8.99,0,0,0-7-8.77V5.29A6.99,6.99,0,0,1,19,12ZM4.27,3,3,4.27,7.73,9H3v6H7l5,5V13.27l4.25,4.25a6.91,6.91,0,0,1-2.25,1.18v2.06a8.94,8.94,0,0,0,3.69-1.81L19.73,21,21,19.73,12,10.73ZM12,4,9.91,6.09,12,8.18Z"/>
             </svg>`
          : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
               <path d="M3,9v6H7l5,5V4L7,9ZM16.5,12A4.5,4.5,0,0,0,14,7.97v8.06A4.47,4.47,0,0,0,16.5,12ZM14,3.23V5.29a6.99,6.99,0,0,1,0,13.42v2.06a8.99,8.99,0,0,0,0-17.54Z"/>
             </svg>`;
      }

      private refreshCaptions() {
        if (!this.ccBtn) return;
        const list = this.captionTracks();

        // No subtitle track for this video → keep the button in place but inert, like YouTube.
        this.ccBtn.classList.toggle('is-disabled', !list.length);
        this.ccBtn.classList.toggle('is-active', list.some(t => t.mode === 'showing'));
      }

      dispose() {
        const player: any = this.player();
        if (player) {
          player.off('volumechange', this.onVolumeChange);
          player.off('texttrackchange', this.onTextTracksChange);
          player.off('loadeddata', this.onTextTracksChange);
          const tracks: any = player.textTracks && player.textTracks();
          if (tracks && tracks.removeEventListener) {
            tracks.removeEventListener('addtrack', this.onTextTracksChange);
            tracks.removeEventListener('removetrack', this.onTextTracksChange);
          }
        }
        super.dispose();
      }

      createEl() {
        return videojs.dom.createEl('div');
      }
    }

    videojs.registerComponent('SettingsButton', SettingsButton);
    videojs.registerComponent('OverlayControls', OverlayControls);
    videojs.registerComponent('CenterCustomizeButton', CenterCustomizeButton);
    videojs.registerComponent('CenterEmailText', CenterEmailText);


    this.player = videojs(this.videoPlayer.nativeElement, {
      controls: true,
      autoplay: true,
      muted: true,
      preload: 'auto',
      fluid: false,
      html5: {
        vhs: {
          overrideNative: this.videos.videos.video_type =="DRM"? false :true
        },
        nativeAudioTracks: false,
        nativeVideoTracks: false
      },
      responsive: false,
      loop: false,
      controlBar: {
        pictureInPictureToggle: true,
        children: [
          'playToggle',               // Play/Pause
          'volumePanel',             // Volume (mute + slider)
          'currentTimeDisplay',      // Current play time
          'timeDivider',             // Divider between current and duration
          'durationDisplay',         // Total duration
          'progressControl',         // Seek bar 
          // 'ForwardButton',           // Custom Forward button
          'remainingTimeDisplay',    // Time left
          'playbackRateMenuButton',  // Playback speed
          'chaptersButton',          // Chapters (if available)
          'descriptionsButton',      // Descriptions (if available)
          'subtitlesButton',         // Subtitle toggle
          // 'captionsButton',          // Captions
          'audioTrackButton',        // Audio tracks
          // "CustomizeButton",
          'fullscreenToggle',         // Fullscreen button
          'qualitySelector',
          'pictureInPictureToggle' // ✅ ADD THIS
        ]
      },
      // playbackRates: [0.5, 1, 1.5, 2, 3], // Optional speeds
    });



    this.titleComp = this.player.addChild('CenterCustomizeButton', {
      title: '',
      pageBack: () => {
        this._location.back();
      }
    });

    this.emailComp = this.player.addChild('CenterEmailText', {
      email: ''
    });
    try {
      this.player.eme();
    } catch (e) {
      console.warn('player.eme() call failed (ignored):', e);
    }

    this.settingsBtn = this.player.getChild('controlBar').addChild('SettingsButton', {
      getAutoPlay: () => this.autoPlayEnabled,
      onToggleAutoPlay: () => this.toggleAutoPlay(),
    }, 8);

    // Floating volume / CC / settings row over the video — same three controls the
    // YouTube embed shows, so both playback paths look alike. The gear reuses the
    // control-bar settings menu instead of building a second one.
    this.player.addChild('OverlayControls', {
      onSettings: () => {
        if (this.settingsBtn && typeof this.settingsBtn.toggleMenu === 'function') {
          this.settingsBtn.toggleMenu();
        }
      }
    });
    if ((videojs as any).Hls) {
      (videojs as any).Hls.xhr.beforeRequest = (options: any) => {
        options.headers = {
          ...(options.headers || {}),
          'Title': this.encrypt() // Custom header with encrypted title
        };
        return options;
      };
    }

    // this.player.getChild('controlBar').addChild('PlayToggle');
    // this.player.getChild('controlBar').addChild('VolumePanel'); 
    // this.player.currentTime(500);

    this.player.on('timeupdate', () => {
      const duration = this.player.duration();
      const current = this.player.currentTime();
      this.accumulateWatchTime(current, this.player.playbackRate(),
        !this.player.paused() && !this.player.seeking());
      if (!duration || isNaN(duration)) return;

      this.handleRemainingTime(duration - current);
    });

    // Seeks and stalls must not count as watching: drop the anchor while they are in
    // flight and re-anchor once playback actually resumes at the new position.
    this.player.on('seeking', () => { this.watchTick = null; });
    this.player.on('seeked', () => { this.watchTick = this.player.currentTime(); });
    this.player.on('playing', () => { this.watchTick = this.player.currentTime(); });

    this.player.on('ended', () => {
      console.log('Video ended');
      this.watchTick = null;
      this.watchTime.flush('video');
      this.handlePlaybackEnded();
    });

    this.player.on('waiting', () => {
      console.log('Video is buffering');
      this.watchTick = null;
    });

    this.player.on('useractive', () => {
      console.log('user is active');
    });

    this.player.on('userinactive', () => {
      console.log('user is inactive');
    });

    this.player.on('pause', () => {
      console.log('video is pause');
      this.watchTick = null;
      this.watchTime.flush('video');
    });

    this.player.on('play', () => {
      console.log('video is play');
    });

    // const PlayToggle = videojs.getComponent('PlayToggle');
    // const centerPlayToggle = new PlayToggle(this.player, {});
    // if (container) {
    //   container.appendChild(centerPlayToggle.el());
    // }


    const centerButton = document.getElementById('center-button') as HTMLElement;
    const backButton = document.getElementById('back-top-button') as HTMLElement;

    if (centerButton) {
      this.player.on('userinactive', () => {
        const isPaused = this.player.paused();
        if (isPaused) {
          centerButton.classList.remove('vjs-hidden');
          backButton.classList.remove('vjs-hidden');
          console.log('Video is paused');
        } else {
          centerButton.classList.add('vjs-hidden');
          backButton.classList.add('vjs-hidden');
          console.log('Video is playing');
        }
      });

      this.player.on('useractive', () => {
        centerButton.classList.remove('vjs-hidden');
        backButton.classList.remove('vjs-hidden');
      });

      this.player.on('pause', () => {
        console.log("🚀 ~ DrmPlayerComponent ~ this.player.on ~ pause:")
        centerButton.classList.remove('vjs-hidden');
        backButton.classList.remove('vjs-hidden');
      });

      this.player.on('play', () => {
        setTimeout(() => {
          if (this.player.userActive() === false) {
            centerButton.classList.add('vjs-hidden');
            backButton.classList.add('vjs-hidden');
          }
        }, 2000);
      });
    }



    // const centerCustomizeButton = new CenterCustomizeButton(this.player, {});
    const centerToogleButton = new CenterToggleButton(this.player, {});
    const centerBackwardButton = new CenterBackwardButton(this.player, {});
    const centerForwardButton = new CenterForwardButton(this.player, {});
    const fastForwardButton = new FastForwardButton(this.player, {});
    const fastBackwardButton = new FastBackwardButton(this.player, {});
    // const emailTextText = new CenterEmailText(this.player, {});
    const customizeContainer = document.getElementById('center-button');
    const backTopContainer = document.getElementById('back-top-button');
    const emailCenterContainer = document.getElementById('email-container');
    const forwardBackwordContainer = document.getElementById('forward-backword-button');

    if (forwardBackwordContainer) {
      forwardBackwordContainer.appendChild(fastForwardButton.el());
      forwardBackwordContainer.appendChild(fastBackwardButton.el());
    }
    // if (backTopContainer) {
    //   backTopContainer.appendChild(centerCustomizeButton.el());
    // }
    // if (emailCenterContainer) {
    //   emailCenterContainer.appendChild(emailTextText.el());
    // }
    if (customizeContainer) {
      customizeContainer.appendChild(centerBackwardButton.el());
      customizeContainer.appendChild(centerToogleButton.el());
      customizeContainer.appendChild(centerForwardButton.el());
    }

  }

  @HostListener('window:beforeunload', ['$event'])
  onReload(event: Event) {
    if ((this.player || this.ytPlayer) && this.videos && this.videos.videos) {
      const watchedTo = this.currentPlaybackTime();
      this.videoanalyticsSave(watchedTo, this.fullParams['video_id']);
      this.videoWatchedDuration(watchedTo, this.videos.videos.seconds);
    }
    // HttpClient calls are cancelled on unload; keepalive gets the last chunk out.
    this.watchTime.flush('video', true);
    /** Only show the browser "leave page" alert when the user is actually leaving,
     * not when we auto/manually navigate to the next episode. */
    if (!this.isNavigatingNext) {
      event.preventDefault();
    }
  }

  ngOnDestroy() {
    // Leaving the player: drop the related list the detail page handed over.
    // (Episode/related switches stay inside this component, so it survives those.)
    localStorage.removeItem('playerRelatedVideos');

    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.disarmPipExitGesture();
    // Leaving the page entirely: never strand a floating PiP window.
    if ((document as any).pictureInPictureElement) {
      (document as any).exitPictureInPicture().catch(() => { });
    }
    this.pipAutoEntered = false;

    if (this.player || this.ytPlayer) {
      const watchedTo = this.currentPlaybackTime();
      console.log('Disposing video player...', watchedTo, '-------', this.fullParams['video_id']);
      if (this.videos && this.videos.videos) {
        this.videoanalyticsSave(watchedTo, this.fullParams['video_id']);
        this.videoWatchedDuration(watchedTo, this.videos.videos.seconds);
      }
      this.watchTime.flush('video');
      if (this.player) {
        this.player.dispose();
      }
      this.destroyYoutubePlayer();
    }
  }

  checkBrowser() {
    console.log("Checking browser compatibility...");
    const agent = navigator.userAgent.toLowerCase();
    const name = navigator.appName;
    this.browser = 'Chrome';
    if (name === 'Microsoft Internet Explorer' || agent.indexOf('trident') > -1 || agent.indexOf('edge/') > -1) {
      this.browser = 'ie';
      if (name === 'Microsoft Internet Explorer') {
        // IE old version (IE 10 or Lower)
      } else if (agent.indexOf('edge/') > -1) {
        this.browser = 'Edge';
      }
    } else if (agent.indexOf('safari') > -1) {
      if (agent.indexOf('opr') > -1) {
        this.browser = 'Opera';
      } else if (agent.indexOf('whale') > -1) {
        this.browser = 'Whale';
      } else if (agent.indexOf('edg/') > -1 || agent.indexOf('Edge/') > -1) {
        this.browser = 'Edge';
      } else if (agent.indexOf('chrome') > -1) {
        this.browser = 'Chrome';
      } else {
        this.browser = 'Safari';
      }
    } else if (agent.indexOf('firefox') > -1) {
      this.browser = 'firefox';
    }
    console.log(`Running in ${this.browser}. ${this.drmType} supported.`);
  }

  isWindowsChrome() {
    return navigator.userAgent.indexOf("Windows") > -1 && navigator.userAgent.indexOf("Chrome") > -1;
  }

  async tryKeySystemAccess(keySystem: string, config: any[]) {
    try {
      await navigator.requestMediaKeySystemAccess(keySystem, config);
      return true;
    } catch {
      return false;
    }
  }

  get baseEmeConfig() {
    return [{
      initDataTypes: ['cenc'],
      videoCapabilities: [{
        contentType: 'video/mp4;codecs="avc1.42E01E"'
      }],
      audioCapabilities: [{
        contentType: 'audio/mp4;codecs="mp4a.40.2"'
      }]
    }];
  }

  get robustnessLevels() {
    return [
      'HW_SECURE_ALL',
      'HW_SECURE_DECODE',
      'HW_SECURE_CRYPTO',
      'SW_SECURE_DECODE',
      'SW_SECURE_CRYPTO'
    ];
  }

  createEmeConfigWithRobustness(videoRobustness: string, audioRobustness: string) {
    return [{
      ...this.baseEmeConfig[0],
      videoCapabilities: [{
        ...this.baseEmeConfig[0].videoCapabilities[0],
        robustness: videoRobustness
      }],
      audioCapabilities: [{
        ...this.baseEmeConfig[0].audioCapabilities[0],
        robustness: audioRobustness
      }]
    }];
  }

  async getWidevineHighestSecurityConfig() {
    const keySystems = this.isWindowsChrome() ?
      ['com.widevine.alpha.experiment', 'com.widevine.alpha'] :
      ['com.widevine.alpha'];

    // Try with robustness levels
    for (const keySystem of keySystems) {
      for (const videoRobustness of this.robustnessLevels) {
        for (const audioRobustness of this.robustnessLevels) {
          const succeed = await this.tryKeySystemAccess(
            keySystem,
            this.createEmeConfigWithRobustness(videoRobustness, audioRobustness)
          );

          if (succeed) {
            if (videoRobustness.startsWith('HW_SECURE_') || audioRobustness.startsWith('HW_SECURE_')) {
              this.supportL1 = true;
            }
            return { keySystem, videoRobustness, audioRobustness };
          }
        }
      }
    }

    // Try without robustness if all failed
    for (const keySystem of keySystems) {
      const succeed = await this.tryKeySystemAccess(keySystem, this.baseEmeConfig);
      if (succeed) {
        return { keySystem, videoRobustness: null, audioRobustness: null };
      }
    }

    return null;
  }

  private async checkSupportedDRM(): Promise<void> {
    const drm = {
      Widevine: { name: 'Widevine', mediaKey: 'com.widevine.alpha' },
      PlayReady: { name: 'PlayReady', mediaKey: 'com.microsoft.playready' },
      FairPlay: { name: 'FairPlay', mediaKey: 'com.apple.fps.1_0' }
    };

    // Different EME configs for different DRM systems
    const widevineConfig = [{
      initDataTypes: ['cenc'],
      videoCapabilities: [{
        contentType: 'video/mp4;codecs="avc1.42E01E"'
      }],
      audioCapabilities: [{
        contentType: 'audio/mp4;codecs="mp4a.40.2"'
      }]
    }];

    const fairplayConfig = [{
      initDataTypes: ['keyids', 'cenc'],
      videoCapabilities: [{
        contentType: 'video/mp4;codecs="avc1.42E01E"'
      }],
      audioCapabilities: [{
        contentType: 'audio/mp4;codecs="mp4a.40.2"'
      }]
    }];

    for (const key in drm) {
      try {
        let config = widevineConfig;
        if (drm[key].name === 'FairPlay') {
          config = fairplayConfig;
        }

        const supported = await this.tryKeySystemAccess(drm[key].mediaKey, config);
        if (supported) {
          // this.drmType = drm[key].name;
          console.log(`${this.drmType} support ok`);

          if (drm[key].name === 'PlayReady') {
            this.supportSl3000 = await this.tryKeySystemAccess('com.microsoft.playready.recommendation.3000', widevineConfig);
          }
        }
      } catch (e) {
        console.log(`${key} :: ${e}`);
      }
    }
  }


  arrayToString(array: Uint8Array): string {
    return String.fromCharCode.apply(null, Array.from(array));
  }

  arrayBufferToString(buffer: ArrayBuffer) {
    const arr = new Uint8Array(buffer);
    const str = String.fromCharCode.apply(String, arr);
    return str;
  }

  base64DecodeUint8Array(input: string) {
    const cleaned = input.replace(/\s/g, '');
    const padded = cleaned + '='.repeat((4 - cleaned.length % 4) % 4);
    const raw = window.atob(padded);
    const rawLength = raw.length;
    const array = new Uint8Array(new ArrayBuffer(rawLength));
    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  base64EncodeUint8Array(input: Uint8Array) {
    // Use standard btoa for base64 encoding
    const binaryString = String.fromCharCode.apply(null, input);
    return btoa(binaryString);
  }

  // FairPlay specific SPC encoding for Pallycon
  encodeFairPlaySPC(keyMessage: Uint8Array): string {
    try {
      console.log('Encoding SPC for Pallycon...');
      console.log('KeyMessage type:', typeof keyMessage);
      console.log('KeyMessage constructor:', keyMessage.constructor.name);
      console.log('KeyMessage length:', keyMessage.length);

      // Ensure we have a proper Uint8Array
      let messageArray: Uint8Array;
      if (keyMessage instanceof ArrayBuffer) {
        messageArray = new Uint8Array(keyMessage);
      } else if (keyMessage instanceof Uint8Array) {
        messageArray = keyMessage;
      } else {
        console.error('Invalid keyMessage type:', typeof keyMessage);
        throw new Error('Invalid keyMessage type');
      }

      // For FairPlay, the keyMessage is already the SPC (Server Playback Context)
      // It's encrypted by Safari with the FairPlay certificate
      // We just need to encode it to base64 for transmission

      // Convert Uint8Array to binary string
      const binaryString = String.fromCharCode.apply(null, messageArray);

      // Encode to base64
      const base64SPC = btoa(binaryString);

      console.log('SPC encoding completed');
      console.log('Binary string length:', binaryString.length);
      console.log('Base64 SPC length:', base64SPC.length);
      console.log('SPC preview (first 50 chars):', base64SPC.substring(0, 50));

      return base64SPC;
    } catch (error) {
      console.error('Error encoding FairPlay SPC:', error);
      throw error;
    }
  }

  // Validate FairPlay SPC data
  validateFairPlaySPC(keyMessage: Uint8Array): boolean {
    try {
      if (!keyMessage || keyMessage.length === 0) {
        console.error('SPC validation failed: keyMessage is empty or null');
        return false;
      }

      // Check minimum SPC size (should be at least 16 bytes)
      if (keyMessage.length < 16) {
        console.error('SPC validation failed: keyMessage too short, length:', keyMessage.length);
        return false;
      }

      // Log SPC structure info
      console.log('SPC validation passed:');
      console.log('- Length:', keyMessage.length, 'bytes');
      console.log('- First 16 bytes:', Array.from(keyMessage.slice(0, 16)).map(b => b.toString(16).padStart(2, '0')).join(' '));

      return true;
    } catch (error) {
      console.error('SPC validation error:', error);
      return false;
    }
  }

  // Validate FairPlay certificate
  validateFairPlayCertificate(certificate: Uint8Array): boolean {
    try {
      if (!certificate || certificate.length === 0) {
        console.error('Certificate validation failed: certificate is empty or null');
        return false;
      }

      // Check minimum certificate size (should be at least 100 bytes for RSA certificate)
      if (certificate.length < 100) {
        console.error('Certificate validation failed: certificate too short, length:', certificate.length);
        return false;
      }

      // Log certificate structure info
      console.log('Certificate validation passed:');
      console.log('- Length:', certificate.length, 'bytes');
      console.log('- First 16 bytes:', Array.from(certificate.slice(0, 16)).map(b => b.toString(16).padStart(2, '0')).join(' '));

      return true;
    } catch (error) {
      console.error('Certificate validation error:', error);
      return false;
    }
  }

  extractChallengeOnly(keyMessage: any) {
    try {
      let keyMessageStr: string;

      if (typeof keyMessage === 'string') {
        keyMessageStr = keyMessage.split('').map(char => {
          const code = char.charCodeAt(0);
          return (code > 31 && code < 127) ? char : '';
        }).join('');

        const challengeRegex = /<PlayReadyKeyMessage[\s\S]*?><LicenseAcquisition[\s\S]*?><Challenge\s+encoding="base64encoded">([\s\S]*?)<\/Challenge>/;
        const match = keyMessageStr.match(challengeRegex);

        if (match && match[1]) {
          return match[1];
        }

        console.warn('Challenge content not found');
        return keyMessageStr;
      } else {
        keyMessageStr = String.fromCharCode.apply(null, new Uint8Array(keyMessage));
        return this.extractChallengeOnly(keyMessageStr);
      }
    } catch (error) {
      console.error('Error extracting Challenge:', error);
      return keyMessage;
    }
  }

  /** Use the "Related Videos" list the video-detail page stored in localStorage when the
   * user hit Play (no API call here), for both the slide-in sidebar and — when nothing
   * else auto-plays — the end-screen "up next" card.
   * @param buildUpNext when true, the top recommendation also becomes the auto-play target.
   */
  getRelatedVideos(buildUpNext: boolean) {
    const slug = this.fullParams && this.fullParams['video_id'];
    if (!slug) return;

    let list: any[] = [];
    try {
      const stored = localStorage.getItem('playerRelatedVideos');
      list = stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.warn('reading stored related videos failed', e);
      list = [];
    }

    const all = Array.isArray(list) ? list.filter(v => v && v.slug) : [];

    // Slide-in sidebar keeps the stored order, minus the video that is playing now.
    this.sidebarVideos = all.filter(v => v.slug !== slug);

    if (!buildUpNext || !all.length) return;

    // Play the stored list as a sequence: the "up next" video is the one AFTER the
    // current video in that list. The first video (the one opened from the detail
    // page) is not in the list, so it starts at index 0. The last one has no next,
    // so playback simply stops there instead of jumping back to the top.
    const currentIndex = all.findIndex(v => v.slug === slug);
    const next = currentIndex === -1 ? all[0] : all[currentIndex + 1];
    if (!next) return;

    // Keep just that one video for the single "up next" card.
    this.relatedVideos = [next];
    this.buildRelatedOverlay();

    // It is also the auto-play target, so the same "up next" countdown + auto-advance
    // flow works (gated on auto_play at play time).
    this.nextUpVideo = next;
    this.nextUpUrl = this.sequenceUrlFor(next);
    this.buildNextUpOverlay();
  }

  toggleSidebar() {
    this.showSidebar = !this.showSidebar;
  }

  /** Play a related video from the sidebar (SPA navigation, same path as "next episode"). */
  playSidebarVideo(v: any) {
    if (!v || !v.slug) return;
    this.showSidebar = false;
    this.onNextPart(this.sequenceUrlFor(v));
  }

  /** Fall back to the default poster when a thumbnail fails to load. */
  onSidebarThumbError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.onerror = null;
    img.src = this.sidebarDefaultPoster;
  }

  /** Build a single "up next" related-video card at the bottom-right and attach it
   * INSIDE the videojs player element, so it stays visible in native fullscreen too. */
  buildRelatedOverlay() {
    if ((!this.player && !this.isEmbedPlayback) || !this.relatedVideos.length) return;

    // Remove a stale overlay if one exists (defensive; episode switches recreate the player).
    if (this.relatedOverlayEl && this.relatedOverlayEl.parentNode) {
      this.relatedOverlayEl.parentNode.removeChild(this.relatedOverlayEl);
    }

    const poster = 'https://dyo1wwfvu9av7.cloudfront.net/jkp/common/default-poster.png';
    const v = this.relatedVideos[0];
    const thumb = v.thumbnail_image || poster;
    const duration = v.video_duration
      ? `<span class="vjs-related-duration">${v.video_duration}</span>`
      : '';

    // High z-index so the card sits ABOVE the center backward/forward buttons and
    // captures clicks (the buttons underneath must not be clickable through it).
    const overlay = document.createElement('div');
    overlay.className = 'vjs-related-overlay vjs-hidden';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'vjs-related-close';
    closeBtn.type = 'button';
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.hideRelatedOverlay(true);
    });

    const card = document.createElement('div');
    card.className = 'vjs-related-card';
    card.innerHTML = `
      <div class="vjs-related-label">Up next</div>
      <div class="vjs-related-thumb">
        <img src="${thumb}" alt="" onerror="this.onerror=null;this.src='${poster}'" />
        <span class="vjs-related-play"></span>
        ${duration}
      </div>
      <div class="vjs-related-title">${v.title || ''}</div>
    `;
    card.addEventListener('click', (e) => {
      e.stopPropagation();
      if (v.slug) {
        this.onNextPart(this.sequenceUrlFor(v));
      }
    });

    overlay.appendChild(closeBtn);
    overlay.appendChild(card);
    // Append as a sibling of #center-button (NOT inside the videojs #my-player wrapper).
    // #my-player has z-index:0 which forms a stacking context, so anything inside it
    // stays BELOW the center backward/forward buttons (z-index:999999) no matter how
    // high its own z-index is — the click would fall through to those buttons.
    this.playerHost.nativeElement.appendChild(overlay);
    this.relatedOverlayEl = overlay;
  }

  showRelatedOverlay() {
    if (!this.relatedOverlayEl || this.relatedDismissed) return;
    this.relatedOverlayEl.classList.remove('vjs-hidden');
    this.relatedOverlayVisible = true;
  }

  /** @param userDismissed true when the user clicked the close button (don't re-show). */
  hideRelatedOverlay(userDismissed = false) {
    if (this.relatedOverlayEl) {
      this.relatedOverlayEl.classList.add('vjs-hidden');
    }
    this.relatedOverlayVisible = false;
    if (userDismissed) {
      this.relatedDismissed = true;
    }
  }

  /** Build the "Up next" auto-advance card (playlist / web-series) with a countdown.
   * Same visual language as the related overlay, but shows the next video and a live
   * "Playing in Xs" countdown. Clicking the card advances immediately; Cancel stops
   * autoplay for the current video. */
  buildNextUpOverlay() {
    if ((!this.player && !this.isEmbedPlayback) || !this.nextUpVideo || !this.nextUpUrl) return;

    // Remove a stale card if one exists (defensive; episode switches recreate the player).
    if (this.nextUpOverlayEl && this.nextUpOverlayEl.parentNode) {
      this.nextUpOverlayEl.parentNode.removeChild(this.nextUpOverlayEl);
    }

    const poster = this.sidebarDefaultPoster;
    const v = this.nextUpVideo;
    const thumb = v.thumbnail_image || poster;
    const duration = v.video_duration
      ? `<span class="vjs-related-duration">${v.video_duration}</span>`
      : '';

    const overlay = document.createElement('div');
    overlay.className = 'vjs-related-overlay vjs-hidden';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'vjs-related-close';
    closeBtn.type = 'button';
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.hideNextUpOverlay(true);
    });

    const card = document.createElement('div');
    card.className = 'vjs-related-card';
    card.innerHTML = `
      <div class="vjs-related-label">Up next · <span class="vjs-nextup-count">15</span>s</div>
      <div class="vjs-related-thumb">
        <img src="${thumb}" alt="" onerror="this.onerror=null;this.src='${poster}'" />
        <span class="vjs-related-play"></span>
        ${duration}
      </div>
      <div class="vjs-related-title">${v.title || ''}</div>
      <button type="button" class="vjs-nextup-cancel">Cancel</button>
    `;
    card.addEventListener('click', (e) => {
      e.stopPropagation();
      this.onNextPart(this.nextUpUrl);
    });

    const cancelBtn = card.querySelector('.vjs-nextup-cancel') as HTMLElement;
    if (cancelBtn) {
      cancelBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.hideNextUpOverlay(true);
      });
    }

    overlay.appendChild(closeBtn);
    overlay.appendChild(card);
    // Append as a sibling of #center-button (see buildRelatedOverlay for the stacking
    // rationale) so the card sits above the center controls and captures clicks.
    this.playerHost.nativeElement.appendChild(overlay);
    this.nextUpOverlayEl = overlay;
    this.nextUpCountEl = card.querySelector('.vjs-nextup-count');
  }

  /** Reveal the up-next card and update the countdown to the real remaining seconds. */
  showNextUpOverlay(remaining: number) {
    if (!this.nextUpOverlayEl || this.nextUpDismissed) return;
    this.nextUpOverlayEl.classList.remove('vjs-hidden');
    this.nextUpVisible = true;
    if (this.nextUpCountEl) {
      this.nextUpCountEl.textContent = String(Math.max(1, Math.ceil(remaining)));
    }
  }

  /** @param userCancelled true when the user cancelled autoplay (don't re-show/auto-advance). */
  hideNextUpOverlay(userCancelled = false) {
    if (this.nextUpOverlayEl) {
      this.nextUpOverlayEl.classList.add('vjs-hidden');
    }
    this.nextUpVisible = false;
    if (userCancelled) {
      this.nextUpDismissed = true;
    }
  }

  /** Find the next video to auto-play from the admin playlist (playlist_videos array).
   * Matches the current video by slug or id and returns the entry that follows it.
   * If the current video isn't part of the returned list (e.g. the playlist landing
   * video), start from the first entry. Returns null when there is no next video or
   * when we aren't in an admin-playlist context. */
  getNextPlaylistVideo(): any {
    if (!this.adminPlaylistSlug) return null;

    const list = this.videos && this.videos.videos && this.videos.videos.playlist_videos;
    if (!Array.isArray(list) || !list.length) return null;

    const currentSlug = this.fullParams && this.fullParams['video_id'];
    const currentId = this.videos && this.videos.videos && this.videos.videos.id;

    const idx = list.findIndex((v: any) =>
      (currentSlug && v.slug === currentSlug) ||
      (currentId != null && v.id === currentId));

    if (idx === -1) {
      // Current video isn't listed → begin the playlist from its first entry.
      return list[0];
    }
    return idx + 1 < list.length ? list[idx + 1] : null;
  }

  /** Build a /watch URL that keeps the current admin playlist context (query param),
   * so the next video also loads playlist_videos and keeps auto-advancing. */
  buildPlaylistWatchUrl(slug: string): string {
    let url = '/watch/' + slug;
    if (this.adminPlaylistSlug) {
      url += '?playlist_id=' + this.adminPlaylistSlug;
    }
    return url;
  }

  onNextPart(url: string) {
    console.log('Next part requested:', url);
    /** Mark this navigation as a "next episode" load so the beforeunload leave-alert is skipped */
    this.isNavigatingNext = true;
    /** SPA navigation — no full page reload. replaceUrl:true so the next episode does NOT
     * pile up a new history entry (back button won't step through every episode).
     * The route param change is handled in the constructor subscription -> loadNextVideo(). */
    this.router.navigateByUrl(url, { replaceUrl: true });
  }

  /* ---------------- third-party embeds (YouTube / Vimeo) ---------------- */

  /** True while this video plays inside a provider iframe instead of videojs. */
  get isEmbedPlayback(): boolean {
    return this.isYoutube || this.isVimeo;
  }

  /** Show/hide the videojs <video> element. It is `position:fixed` at 100vw x 100vh, so
   * while an embed plays it has to be hidden or its black box covers the provider iframe.
   * Done in code rather than with a template binding because loadNextVideo() recreates the
   * element outside Angular on every episode switch — a binding would never reach it. */
  private setVideojsElementHidden(hidden: boolean) {
    const el = this.videoPlayer && this.videoPlayer.nativeElement;
    if (!el) {
      return;
    }
    if (hidden) {
      el.classList.add('embed-inactive');
    } else {
      el.classList.remove('embed-inactive');
    }
  }

  /** Start the YouTube path: poster/title state now, iframe once Angular has rendered the
   * host element (it lives behind *ngIf="isYoutube"). */
  initYoutubePlayer() {
    const video = this.videos.videos;
    this.embedTitle = video.title || '';
    this.ytPoster = video.poster_image || video.thumbnail_image || this.sidebarDefaultPoster;
    this.ytShowPoster = true;
    this.embedHovered = false;
    document.getElementsByTagName('body')[0].classList.add('body-video-page');
    setTimeout(() => this.mountYoutubePlayer(), 0);
  }

  /** Vimeo videos are a plain embed iframe — Vimeo owns the poster, controls and playback,
   * so there is nothing to instrument here beyond the url and our own back button/title. */
  initVimeoPlayer() {
    const video = this.videos.videos;
    this.embedTitle = video.title || '';
    this.embedHovered = false;
    this.vimeoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.toVimeoEmbedUrl(video.embed_url));
    document.getElementsByTagName('body')[0].classList.add('body-video-page');
  }

  /** embed_url holds whatever the admin pasted — usually the share link
   * (https://vimeo.com/<id>/<hash>?share=copy...), sometimes a player url already. Only
   * player.vimeo.com/video/<id> loads in an iframe, and unlisted videos need the privacy
   * hash carried over as ?h=, so normalise before binding it to the iframe src. */
  private toVimeoEmbedUrl(embedUrl: any): string {
    const value = String(embedUrl == null ? '' : embedUrl).trim();
    if (!value || value.indexOf('player.vimeo.com') !== -1) {
      return value;
    }
    const match = value.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([A-Za-z0-9]+))?/);
    if (!match) {
      // Never fall back to the raw value: anything without a scheme is resolved against the
      // watch page, so the iframe would load this app inside itself and land on video-not-found.
      console.error('Vimeo embed url not recognised', value);
      return '';
    }
    return 'https://player.vimeo.com/video/' + match[1] + (match[2] ? '?h=' + match[2] : '');
  }

  private mountYoutubePlayer() {
    const host = document.getElementById('yt-host');
    const videoId = this.extractYoutubeId(this.videos.videos.embed_url);
    if (!host || !videoId) {
      console.error('YouTube player not mounted — missing host or video id', this.videos.videos.embed_url);
      return;
    }

    // The YouTube iframe API REPLACES the element it mounts on, so hand it a throwaway
    // div instead of the Angular-rendered host (which Angular still needs to own).
    host.innerHTML = '';
    const mount = document.createElement('div');
    mount.id = 'yt-player';
    host.appendChild(mount);

    // Resume where the user left off — the same `seconds` the videojs path seeks to.
    const startSeconds = Math.floor(Number(this.videos.videos.seconds) || 0);

    this.ytPlayer = new YTPlayer(mount, {
      width: '100%',
      height: '100%',
      autoplay: true,
      controls: true,
      keyboard: true,
      fullscreen: true,
      annotations: false,
      modestBranding: true,
      related: false,
      playsInline: true,
      timeupdateFrequency: 1000,
      start: startSeconds
    });
    this.ytPlayer.load(videoId, true, startSeconds);

    this.ytPlayer.on('playing', () => {
      // YouTube blocks unmuted autoplay, so the poster stays up until playback really
      // starts; from then on it never comes back (pausing shows YouTube's own UI).
      this.zone.run(() => this.ytShowPoster = false);
      this.watchTick = this.ytPlayer.getCurrentTime();
    });

    // yt-player has no seeking event; a seek shows up as a jump far bigger than the
    // 1 s polling step and is discarded by accumulateWatchTime's step limit.
    this.ytPlayer.on('paused', () => {
      this.watchTick = null;
      this.watchTime.flush('video');
    });
    this.ytPlayer.on('buffering', () => { this.watchTick = null; });

    this.ytPlayer.on('timeupdate', (seconds: number) => {
      const rate = (typeof this.ytPlayer.getPlaybackRate === 'function') ? this.ytPlayer.getPlaybackRate() : 1;
      this.accumulateWatchTime(seconds, rate, true);
      const duration = this.ytPlayer.getDuration();
      if (!duration) {
        return;
      }
      this.zone.run(() => this.handleRemainingTime(duration - seconds));
    });

    this.ytPlayer.on('ended', () => {
      this.watchTick = null;
      this.watchTime.flush('video');
      this.zone.run(() => this.handlePlaybackEnded());
    });

    this.ytPlayer.on('error', (err: any) => {
      console.error('YouTube player error', err);
    });
  }

  /** Poster click — YouTube refused to autoplay, so start playback on this user gesture. */
  playYoutube() {
    if (this.ytPlayer) {
      this.ytPlayer.play();
    }
  }

  /** embed_url is normally a bare YouTube id, but accept full watch/embed/youtu.be URLs too. */
  private extractYoutubeId(embedUrl: any): string {
    const value = String(embedUrl == null ? '' : embedUrl).trim();
    if (!value) {
      return '';
    }
    if (value.indexOf('/') === -1 && value.indexOf('?') === -1) {
      return value;
    }
    const match = value.match(/(?:v=|\/embed\/|youtu\.be\/|\/v\/|\/shorts\/)([A-Za-z0-9_-]{11})/);
    return match ? match[1] : value;
  }

  private destroyYoutubePlayer() {
    this.watchTick = null;
    if (this.ytPlayer) {
      try {
        this.ytPlayer.destroy();
      } catch (e) {
        console.warn('YouTube player destroy failed', e);
      }
      this.ytPlayer = null;
    }
    // The iframe replaced our throwaway mount div, so clear whatever is left behind.
    const host = document.getElementById('yt-host');
    if (host) {
      host.innerHTML = '';
    }
  }

  /* ---------------- shared by both playback paths ---------------- */

  /** Playback position of whichever player is driving the current video. */
  private currentPlaybackTime(): number {
    if (this.ytPlayer) {
      return this.ytPlayer.getCurrentTime();
    }
    if (this.player) {
      return this.player.currentTime();
    }
    return 0;
  }

  /** End-of-video UI, driven by each player's timeupdate: the "up next" countdown when
   * auto_play is on, otherwise the related-videos grid for a manual pick. */
  private handleRemainingTime(remaining: number) {
    // Auto-play next (web-series episode / admin playlist / recommended): show the
    // "up next" card with a live countdown in the last 15s — ONLY when the customer
    // has auto_play enabled. The number reflects the real remaining time, so it hits
    // 0 exactly when the video ends and the 'ended' handler auto-advances.
    if (this.autoPlayEnabled && this.nextUpUrl) {
      if (remaining <= this.relatedShowThreshold && remaining > 0) {
        this.showNextUpOverlay(remaining);
      } else if (remaining > this.relatedShowThreshold && this.nextUpVisible) {
        // User seeked back into the middle of the video — hide the card again.
        this.hideNextUpOverlay();
      }
      return;
    }

    // auto_play off (or nothing to auto-advance to): reveal the related-videos grid in
    // the last few seconds so the user can pick the next video manually — no auto-play.
    if (remaining <= this.relatedShowThreshold && remaining > 0) {
      this.showRelatedOverlay();
    } else if (remaining > this.relatedShowThreshold && this.relatedOverlayVisible) {
      // User seeked back into the middle of the video — hide the grid again.
      this.hideRelatedOverlay();
    }
  }

  /** Auto-advance to the next video (web-series episode / playlist / recommended) only
   * when auto_play is enabled AND the user hasn't cancelled it for this video. Otherwise
   * stop and show the related-videos end screen for a manual pick. */
  private handlePlaybackEnded() {
    if (this.autoPlayEnabled && this.nextUpUrl && !this.nextUpDismissed) {
      this.onNextPart(this.nextUpUrl);
    } else {
      this.showRelatedOverlay();
    }
  }

  async playVideo(): Promise<void> {
    console.log("video playing.............", this.drmType)
    console.log("HLS URI:", this.hlsUri)
    console.log("FairPlay Token:", this.fairplayToken)
    console.log("FairPlay Cert URI:", this.fairplayCertUri)

    document.getElementsByTagName('body')[0].classList.add('body-video-page');

    return new Promise((resolve, reject) => {
      // Validate FairPlay configuration
      if (this.drmType === 'FairPlay') {
        if (!this.hlsUri) {
          console.error('HLS URI is required for FairPlay');
          reject(new Error('HLS URI is required for FairPlay'));
          return;
        }
        if (!this.fairplayToken) {
          console.error('FairPlay token is required');
          reject(new Error('FairPlay token is required'));
          return;
        }
      }
      this.player.ready(async () => {
        try {

          // this.player.hlsQualitySelector({
          //   displayCurrentQuality: true
          // }); 

          // const qualityLevels = this.player.qualityLevels();
          // qualityLevels.on('addqualitylevel', () => {
          //   for (let i = 0; i < qualityLevels.length; i++) {
          //     const level = qualityLevels[i];
          //     console.log(`Quality Level ${i}: ${level.height}p`);
          //     // Sirf 540p allow karo
          //     if (level.height === 540) {
          //       level.enabled = true;
          //       console.log('✅ 540p Enabled');
          //     } else {
          //       level.enabled = false;
          //     }
          //   }
          // }); 
          if (this.titleComp) {
            this.titleComp.setTitle(this.videos.videos.title);
          }

          if (this.emailComp) {
            this.emailComp.setEmail(this.userName);
          }
          let playerConfig: any;

          const controlBar = this.player.getChild('controlBar');
          // controlBar.addChild('RewindButton', {}, 0);
          // controlBar.addChild('ForwardButton', {}, 2);

          // this.player.getChild('controlBar').addChild('CustomizeButton', {
          //   onNext: (e:string) => this.onNextPart(e)
          // });

          if ((this.drmType || '').toLowerCase() === 'fairplay') {
            playerConfig = {
              src: this.hlsUri,
              type: 'application/x-mpegURL',
              keySystems: {
                'com.apple.fps': {
                  getCertificate: (emeOptions, callback) => {
                    console.log('=== getCertificate called ===');

                    videojs.xhr({
                      url: this.fairplayCertUri,
                      method: 'GET',
                    }, (err, response, responseBody) => {
                      if (err) {
                        console.error('Certificate error:', err);
                        callback(err);
                        return;
                      }

                      // Base64 decode karo
                      const cert = this.base64DecodeUint8Array(responseBody);
                      console.log('Certificate loaded, size:', cert.length);
                      callback(null, cert);
                    });
                  },

                  getContentId: (emeOptions, initData) => {
                    const contentIdString = this.arrayToString(new Uint8Array(initData));
                    const contentId = contentIdString.substring(contentIdString.indexOf('skd://') + 6);
                    console.log('ContentId extracted:', contentId);
                    return contentId;
                  },

                  getLicense: (emeOptions, contentId, keyMessage, callback) => {
                    console.log('=== getLicense called ===');

                    const encodedSPC = this.base64EncodeUint8Array(keyMessage);
                    const formBody = 'spc=' + encodedSPC;

                    videojs.xhr({
                      url: this.licenseUri,
                      method: 'POST',
                      responseType: 'text',
                      body: formBody,
                      headers: {
                        'Content-type': 'application/x-www-form-urlencoded',
                        'pallycon-customdata-v2': this.fairplayToken
                      }
                    }, (err, response, responseBody) => {
                      if (err) {
                        console.error('License error:', err);
                        callback(err);
                        return;
                      }

                      const decodedCKC = this.base64DecodeUint8Array(responseBody);
                      console.log('License received, CKC size:', decodedCKC.length);
                      callback(null, decodedCKC);
                    });
                  }
                }
              },
              html5: {
                vhs: { overrideNative: false },
                nativeAudioTracks: true,
                nativeVideoTracks: true
              }
            };
          } else if ((this.drmType || '').toLowerCase() === 'playready') {
            playerConfig = {
              src: this.dashUri,
              type: 'application/dash+xml',
              keySystems: {
                'com.microsoft.playready': {
                  url: this.licenseUri,
                  licenseHeaders: {
                    'pallycon-customdata-v2': this.playreadyToken
                  }
                }
              }
            };
          } else if ((this.drmType || '').toLowerCase() === 'widevine') {
            playerConfig = {
              src: this.dashUri,
              type: 'application/dash+xml',
              keySystems: {
                'com.widevine.alpha': {
                  url: this.licenseUri,
                  licenseHeaders: {
                    'pallycon-customdata-v2': this.widevineToken,
                  },
                  videoRobustness: 'SW_SECURE_DECODE', // Safe default; can use 'HW_SECURE_ALL' if supported
                  audioRobustness: 'SW_SECURE_CRYPTO',
                },
              },
            };
          } else {
            console.log("This is not DRM Video-------------------------------------------------->>>>>>>>>>>>>>>>");
            document.cookie = `video_meta=${this.encrypt()}; Secure; SameSite=None; path=/`;

            playerConfig = {
              src: this.hlsUri,
              type: 'application/x-mpegURL', 
            };
          }
          console.log("Final DRM player config:", JSON.stringify(playerConfig, null, 2));
          console.log(this.drmType + " playerConfig (real object):", playerConfig);
          console.dir(playerConfig, { depth: null });
          this.player.src(playerConfig);

          this.player.on('emeinitialize', () => console.log('EME initialized'));
          this.player.on('keysessioncreated', (e) => console.log('Key session created', e));
          this.player.on('keyadded', () => console.log('Key added'));
          this.player.on('keystatuschange', (e) => console.log('Key status change', e));
          this.player.on('error', () => console.error('video.js error event', this.player.error()));

          this.player.on('error', (error) => {
            console.error('Video.js error:', error);
            console.error('Error details:', this.player.error());
          });

          this.player.on('loadedmetadata', () => {
            this.addSubtitlesToPlayer();
            console.log('FairPlay DRM negotiation started...');
          });

          // Attempt autoplay (muted)
          const playPromise = this.player.play();

          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                console.log("Autoplay succeeded (muted)");

                // Try to unmute after 1000ms
                setTimeout(() => {
                  try {
                    if (this.player.muted()) {
                      this.player.muted(false);
                    }
                    // this.player.muted(false);
                    // console.log("Attempting to unmute");

                    // // If still muted, show unmute button
                    // if (this.player.muted()) {
                    //   this.unmuteButtonVisible = true;
                    // }
                  } catch (error) {
                    console.warn("Unmute failed:", error);
                    this.unmuteButtonVisible = true;
                  }
                }, 1);
              })
              .catch((error) => {
                console.warn("Autoplay failed:", error);
                // this.showPlayButton = true;
              });
          }

          resolve();
        } catch (error) {
          reject(error);
        }
      });
    });
  }


  registerCustomButtons(url: string): void {

    if (!this.showNextButton) return;

    class CustomizeButton extends videojs.getComponent('Button') {
      private onNext: ((e: string) => void) | null = null;
      /** Read the next-episode URL from options (per instance) — NOT from a closure.
       * The class is registered with videojs only once, so a captured `url` would
       * stay stuck on the first episode's value on every later episode. */
      private nextUrl: string = '';

      constructor(player: any, options: any) {
        super(player, options);

        this.onNext = options.onNext || null;
        this.nextUrl = options.nextUrl || '';

        this.controlText('Next Part');
        this.addClass('vjs-customize-button');
        this.el().textContent = 'Next part »';
      }

      handleClick() {
        if (this.onNext) {
          this.onNext(this.nextUrl);   // ✅ yahin se call hoga
        }
      }
    }

    if (!videojs.getComponent('CustomizeButton')) {
      videojs.registerComponent('CustomizeButton', CustomizeButton);
    }

    // ✅ SINGLE SOURCE OF TRUTH — pass the fresh URL as an option so every
    // episode's button navigates to ITS own next episode.
    this.player.getChild('controlBar').addChild('CustomizeButton', {
      nextUrl: url,
      onNext: (u: string) => this.onNextPart(u)
    });
  }




  // Add this to your component class
  unmuteButtonVisible = false;

  // Test FairPlay endpoints
  async testFairPlayEndpoints(): Promise<boolean> {
    try {
      // Test certificate endpoint
      console.log('Testing certificate endpoint:', this.fairplayCertUri);
      const certResponse = await fetch(this.fairplayCertUri);
      console.log('Certificate response status:', certResponse.status);
      console.log('Certificate response headers:', certResponse.headers);

      if (!certResponse.ok) {
        console.error('FairPlay certificate endpoint test failed:', certResponse.status);
        const errorText = await certResponse.text();
        console.error('Certificate error response:', errorText);
        return false;
      }

      const certArrayBuffer = await certResponse.arrayBuffer();
      const certArray = new Uint8Array(certArrayBuffer);
      console.log('FairPlay certificate endpoint test passed, certificate size:', certArray.length);

      // Validate the certificate
      if (!this.validateFairPlayCertificate(certArray)) {
        console.error('Certificate validation failed in endpoint test');
        return false;
      }

      // Test license endpoint with a dummy request
      const testFormData = new FormData();
      testFormData.append('spc', 'dummy');
      testFormData.append('contentId', 'vi25189');

      console.log('Testing license endpoint:', this.licenseUri);
      const licenseResponse = await fetch(this.licenseUri, {
        method: 'POST',
        headers: {
          'pallycon-customdata-v2': this.fairplayToken
        },
        body: testFormData
      });

      console.log('License response status:', licenseResponse.status);
      const licenseResponseText = await licenseResponse.text();
      console.log('License response:', licenseResponseText);

      // Even if it returns an error, the endpoint is reachable
      console.log('FairPlay license endpoint test completed:', licenseResponse.status);
      return true;
    } catch (error) {
      console.error('FairPlay endpoint test failed:', error);
      return false;
    }
  }

  // Test SPC encoding with sample data
  testSPCEncoding(): void {
    try {
      // Create a sample keyMessage (this is just for testing the encoding)
      const sampleKeyMessage = new Uint8Array([
        0x01, 0x02, 0x03, 0x04, 0x05, 0x06, 0x07, 0x08,
        0x09, 0x0A, 0x0B, 0x0C, 0x0D, 0x0E, 0x0F, 0x10
      ]);

      console.log('Testing SPC encoding with sample data...');
      console.log('Sample keyMessage:', Array.from(sampleKeyMessage).map(b => b.toString(16).padStart(2, '0')).join(' '));

      const encodedSPC = this.encodeFairPlaySPC(sampleKeyMessage);
      console.log('Encoded SPC:', encodedSPC);

      // Test validation
      const isValid = this.validateFairPlaySPC(sampleKeyMessage);
      console.log('SPC validation result:', isValid);

    } catch (error) {
      console.error('SPC encoding test failed:', error);
    }
  }

  // Test FairPlay license request with sample data
  async testFairPlayLicenseRequest(): Promise<void> {
    try {
      console.log('Testing FairPlay license request...');

      // First, test certificate fetching
      console.log('Testing certificate fetch...');
      const certResponse = await fetch(this.fairplayCertUri);
      if (!certResponse.ok) {
        console.error('Certificate test failed:', certResponse.status);
        return;
      }

      const certArrayBuffer = await certResponse.arrayBuffer();
      const certArray = new Uint8Array(certArrayBuffer);
      console.log('Certificate test passed, size:', certArray.length);

      // Validate certificate
      if (!this.validateFairPlayCertificate(certArray)) {
        console.error('Certificate validation failed in test');
        return;
      }

      // Create a sample SPC (this should match what Safari generates)
      const sampleSPC = new Uint8Array([
        0x00, 0x00, 0x00, 0x01, // Version
        0x00, 0x00, 0x00, 0x00, // Reserved
        0x00, 0x00, 0x00, 0x10, // SPC length
        0x01, 0x02, 0x03, 0x04, 0x05, 0x06, 0x07, 0x08,
        0x09, 0x0A, 0x0B, 0x0C, 0x0D, 0x0E, 0x0F, 0x10  // SPC data
      ]);

      const encodedSPC = this.encodeFairPlaySPC(sampleSPC);
      const testContentId = 'test-content-id';

      const formData = new FormData();
      formData.append('spc', encodedSPC);
      formData.append('contentId', testContentId);

      console.log('Sending test license request...');
      console.log('Test SPC:', encodedSPC);
      console.log('Test contentId:', testContentId);

      const response = await fetch(this.licenseUri, {
        method: 'POST',
        headers: {
          'pallycon-customdata-v2': this.fairplayToken
        },
        body: formData
      });

      const responseText = await response.text();
      console.log('Test license response status:', response.status);
      console.log('Test license response:', responseText);

    } catch (error) {
      console.error('Test FairPlay license request failed:', error);
    }
  }

  unmuteVideo() {
    try {
      this.player.muted(false);
      this.unmuteButtonVisible = false;
    } catch (error) {
      console.error("Manual unmute failed:", error);
    }
  }
  skipBackward() {
    if (this.player) {
      const currentTime = this.player.currentTime();
      this.player.currentTime(Math.max(0, currentTime - 10));
    }
  }

  updateCurrentTime(seonds: number) {
    if (this.player) {
      this.player.currentTime(seonds);
    }
  }

  skipForward() {
    if (this.player) {
      const duration = this.player.duration();
      const currentTime = this.player.currentTime();
      this.player.currentTime(Math.min(duration, currentTime + 10));
    }
  }

  togglePlay() {
    if (this.player) {
      if (this.player.paused()) {
        this.player.play().catch(e => console.warn("Play failed:", e));
      } else {
        this.player.pause();
      }
    }
  }

  PageBack() {
    // if (this.adminPlaylistSlug) {
    //   this.router.navigate(['playlist/' + this.adminPlaylistSlug]);
    // } else {
    this._location.back();
    // }
  }

  /**
   * Hands the media time elapsed since the previous timeupdate to WatchTimeService.
   * Only small forward steps count: videojs ticks every ~250 ms and yt-player every 1 s,
   * so a genuine step is at most ~1 s × playbackRate, while a seek jumps far beyond that
   * (or backwards) and is discarded. Mirrors accumulatePlayedTime() in the audio player.
   */
  private accumulateWatchTime(now: number, rate: number, active: boolean) {
    if (!active || typeof now !== 'number' || isNaN(now)) {
      this.watchTick = null;
      return;
    }
    if (this.watchTick !== null) {
      const delta   = now - this.watchTick;
      const maxStep = 2 * (rate || 1);
      if (delta > 0 && delta < maxStep) {
        this.watchTime.add('video', delta);
      }
    }
    this.watchTick = now;
  }

  videoanalyticsSave(minutes: number, videoId: string) {
    console.log("Saving video analytics data..................................... minutes, ", minutes, "v ideoId ", videoId);
    this.apiService.callPostAPI('v2/videoanalytics', { seconds: minutes, video_slug: videoId }, environment.analyticsApiUrl).subscribe(data => {
      console.log("video analytics data saved successfully", data);
    }, error => {
      this.apiService.failureResponse(error);
    });
  }

  videoWatchedDuration(end_time: number, start_time: number) {
    console.log("watched-duration..................................... end_time, ", end_time, " start_time ", start_time);
    this.apiService.callPostAPI('v2/watched-duration', { end_time: end_time, start_time: start_time }, environment.analyticsApiUrl).subscribe(data => {
      console.log("video analytics data saved successfully", data);
    }, error => {
      this.apiService.failureResponse(error);
    });
  }

  playNextPart() {
    console.log("Playing next part if available...............................");
    if (this.playNextPartUrl) {
      window.location.href = this.playNextPartUrl;
    }
  }

  goToSubscribe() {
    this.router.navigate(['/subscription']);
  }


}